import React from "react";
import { bindActionCreators } from "redux";
import { connect } from "react-redux";
import { withAlert } from "react-alert";
import PropTypes from "prop-types";
import * as Modal from "react-modal";
import { Tab, Tabs, TabList, TabPanel } from "react-tabs";
import { Link } from "react-router-dom";
import ReCAPTCHA from "react-google-recaptcha";
import * as SecretKeys from "../../ENV.json";
import Linkify from 'react-linkify';
import Validator from "validator";
import {
  updateConsumerUser,
  getConsumerUser,
  getAllPlans,
  getBusinessUser,
  updateUserSignatureWithDocs,
  updateBusinessUser,
  planPriceChange,
  requestCreateFusebillCustomer,
  getAllStates,
  requestSaveFusebillPaymentMethod,
  requestSaveFusebillCardId,
} from "../../Actions/actions";
// import TermAndCondition from "./termsAndCondition";
import TermAndCondition from "./termsAndConditionPartner";
import CardInputField from "./cardInputField";
import CardInputMaskinking from "./cardInputMaskinking";
import logoImage from "../../images/logo.png";
import isEmpty from "lodash/isEmpty";
import loader from "../../images/Spin-1s-107px.gif";
import Swal from "sweetalert2";


const customStyles = {
  content: {
    position: "unset",
    top: "50%",
    left: "50%",
    right: "auto",
    bottom: "auto",
    // marginRight: '-50%',
    // transform: 'translate(-50%, -50%)',
    margin: "100px auto",
    maxWidth: "359px",
    overflow: "initial",
    height: "295px",
    width: "100%"
  }
};

// import loader from '../../images/Spin-1s-107px.gif';

class ProfileTermsPage extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      publicApiKey: SecretKeys.FUSEBILL.PUBLIC_API_KEY,
      zendeskLink:"https://collectively.zendesk.com",
      IsConusmerForm: localStorage.getItem("roleName") === "Consumer" ? 2 : 1,
      signatureDefaultValue: `${localStorage.getItem(
        "firstName"
      )} ${localStorage.getItem("lastname")}`,
      signatureFontFamily: "",
      isLoading: false,
      readDisclaimer: 0,
      readPrivacyPolicy: 0,
      readLetterOfAgency: 0,
      readUserAgreement: 0,
      userId: localStorage.getItem("userId"),
      roleName: localStorage.getItem("roleName"),
      defaultIndex: 1,
      cPhone: "",
      customerId: '',
      makeDefault: true,
      countryId:  "USA",
      cCountryCode: "",
      cFirstName: "",
      cLastName: "",
      cEmployer: "",
      cEmail: "",
      file: "",
      totalTaxId: "",
      planPriceId: "",
      AllPlansForMember1: [],
      finalSubmitSignature: false,
      IsSignatureForm: false,
      tabValue: 0,
      userIdState: localStorage.getItem("userId"),
      stateSuccessB: [],
      stateSuccess: [],
      mobilePhone: "",
      firstName: "",
      lastName: "",
      state: "",
      email: "",
      startingYear: "",
      companyTitle: "",
      workPhoneNumber: "",
      streeAddress: "",
      city: "",
      zipCode: "",
      taxId: "",
      industryTypeId: "",
      webSite: "",
      separateTaxId: "",
      companyName: "",
      bankruptcyStatus: "",
      dissolvedStatus: "",
      acceptCC: "",
      cognitoClientId: "",
      countryCode: "",
      workCountryCode: "",
      firstNameFormData: "",
      lastNameFormData: "",
      emailFormData: "",
      streeAddressFomData: "",
      enableButtonT: localStorage.getItem("roleName") !== "Consumer",
      uploadDOcData1: [],
      planChangeTriggered: false,
      createFusebillCustomerTriggered: false,
      isLoader: false,
      isLoaderDataSave: false,
      streeAddress2: '',
      intervalId: 0,
      successModalStatus: false,
      failureModalStatus: false,
      durationCheckout: 0,
      discountCheckout: 0,
      selectedPlanAmount: "",
      fileData: "",
      cardErrors: {
        cardMonthError: true,
        cardNumberError: true,
        cardFirstNameError: true,
        cardLastNameError: true,
        recaptchaTokenError: true
      },

      cardErrorsState: {
        cardMonthError: true,
        cardNumberError: true,
        cardFirstNameError: true,
        cardLastNameError: true,
        recaptchaTokenError: true
      },
      stateName: "",

      planName: "",
      activeTab1: false,
      activeTab2: false,
      activeTab3: false,
      activeTab4: false,
      activeTab1Consumer: false,
      activeTab2Consumer: false,
      durationData: "1 Month",
      activePlanForBussness: "Premium",
      showplanDetail: false,
      cardNumber: "",
      cardLastName: "",
      cardFirstName: "",
      stateCard: "",
      cardMonth: "",
      cardYear: "",
      cardCvv: "",
      cardAddress: "",
      cardAddress2: "",
      cardCity: "",
      cardZipCode: "",
      sameAddress: false,
      recaptchaToken: "",
      fusebillPlanId: "",
      fusebillPlanFrequencyId: "",
      connectFusebill: "",
      cClaimUpdateText: "",
      cRoleName: "Consumer",
      cOptionsSinceAdds: "",
      legalTabFilled: false,
      planId: '',

      showTabPlan: false,
      showTabPlan1: false,
      showTabPlan2: false,
      showTabPlan3: false,
      showTabPlan4: false,
      showTabPlan5: false,
      isBussnessState: false,
      planBasicAndUpdateUserSignatureWithDocsApiTriggered: false
    };
    this.onPlanSelectBar = this.onPlanSelectBar.bind(this);
    this._onSelectCard = this._onSelectCard.bind(this);
  }


  // defaultIndex

  scrollStep = () => {
    if (window.pageYOffset === 0) {
      clearInterval(this.state.intervalId);
    }
    window.scroll(0, window.pageYOffset - this.props.scrollStepInPx);
  };

  onPlanSelectBar(id, selectedPlanAmount, planData) {
    this.setState({
      planPriceId: id,
      IsConusmerForm: 2
    });

    let data;
    if (
      planData.planName !== "Basic" &&
      planData.planName !== "Basic Outsourced"
    ) {
      data = {
        userId: localStorage.getItem("userId"),
        planPriceId: id,
        paymentStatus: "pending",
        selectedPlanName: planData.planName,
        selectedPlanAmount
      };
    } else {
      data = {
        userId: localStorage.getItem("userId"),
        planPriceId: id,
        paymentStatus: "paid",
        selectedPlanName: planData.planName,
        selectedPlanAmount
      };
    }

    this.props.planPriceChange(data);
    const intervalId = setInterval(
      this.scrollStep.bind(this),
      this.props.delayInMs
    );
    this.setState({
      intervalId
    });
    //-----------------------------
    // this.onPlanSelectSubmit();
  }

  componentWillMount() {
    const { roleName, userId } = this.state;
    const { userInfo } = this.props.data;
    localStorage.setItem('changePlan',false)
    if (roleName === "Consumer") {
      this.props.getConsumerUser(userId);
      this.setState({
        defaultIndex: 0
      })
    }
    if (roleName === "Business-User") {
      this.props.getBusinessUser(userId);
      this.setState({
        defaultIndex: 1
      })
    }
    this.props.getAllStates();
    this.props.getAllPlans({
      pageNumber: 0,
      pageSize: 20,
      searchKeyword: "",
      planUserType: "Both",
      userId: userInfo
      && userInfo.userObject
      && userInfo.userObject.userDto
      && userInfo.userObject.userDto.affiliateId
      && userInfo.userObject.userDto.affiliateKey !== "undefined"
          ? userInfo.userObject.userDto.affiliateId
          : 0,
      // affiliateKey:
      //   this.props.match.params.affiliateKey !== undefined
      //     ? this.props.match.params.affiliateKey
      //     : userInfo && userInfo.userObject.userDto.affiliateKey
      affiliateKey:
        userInfo
        && userInfo.userObject
        && userInfo.userObject.userDto
        && userInfo.userObject.userDto.affiliateKey
          ? userInfo.userObject.userDto.affiliateKey
          : ""
    });
    const intervalId = setInterval(
      this.scrollStep.bind(this),
      this.props.delayInMs
    );
    this.setState({
      intervalId
    });
  }

  componentDidUpdate() {
    const {
      ConsumerUserData,
      AllPlansForMember,
      BusinessUserProfileData,
      uploadDOcData
    } = this.props.data;
    const {
      stateSuccess,
      AllPlansForMember1,
      stateSuccessB,
      uploadDOcData1
    } = this.state;
    if (stateSuccess !== ConsumerUserData) {
      this.setState({
        cognitoClientId: ConsumerUserData.cognitoClientId,
        cPhone: ConsumerUserData.mobilePhone,
        cCountryCode: ConsumerUserData.countryCode,
        cFirstName: ConsumerUserData.firstName,
        cLastName: ConsumerUserData.lastName,
        cEmployer: ConsumerUserData.employer,
        cEmail: ConsumerUserData.email,
        stateSuccess: ConsumerUserData,
        planPriceId: 23
      });
    }
    if (stateSuccessB !== BusinessUserProfileData) {
      this.setState({
        mobilePhone: BusinessUserProfileData.mobilePhone,
        firstName: BusinessUserProfileData.firstName,
        lastName: BusinessUserProfileData.lastName,
        state: BusinessUserProfileData.stateId,
        email: BusinessUserProfileData.email,
        startingYear: BusinessUserProfileData.startingYear,
        companyTitle: BusinessUserProfileData.companyTitle,
        workPhoneNumber: BusinessUserProfileData.workPhoneNumber,
        streeAddress: BusinessUserProfileData.streeAddress,
        streeAddress2: BusinessUserProfileData.streetAddress2,
        city: BusinessUserProfileData.city,
        zipCode: BusinessUserProfileData.zipCode,
        taxId: BusinessUserProfileData.taxId,
        industryTypeId: BusinessUserProfileData.industryTypeId,
        webSite: BusinessUserProfileData.webSite,
        separateTaxId: BusinessUserProfileData.separateTaxId,
        companyName: BusinessUserProfileData.companyName,
        totalTaxId: BusinessUserProfileData.totalTaxId,
        bankruptcyStatus: BusinessUserProfileData.bankruptcyStatus,
        dissolvedStatus: BusinessUserProfileData.dissolvedStatus,
        acceptCC: BusinessUserProfileData.acceptCC,
        cognitoClientId: BusinessUserProfileData.cognitoClientId,
        countryCode: BusinessUserProfileData.countryCode,
        workCountryCode: BusinessUserProfileData.workCountryCode,
        enterpriseType: BusinessUserProfileData.enterpriseType,
        stateSuccessB: BusinessUserProfileData,
        customerId: BusinessUserProfileData.fusebillCustomerId,
        stateName: BusinessUserProfileData.stateName,
        isBussnessState: BusinessUserProfileData.registeredVia === "Admin" ? true : false
      });
    }

    if (uploadDOcData1 !== uploadDOcData) {
      this.setState({
        uploadDOcData1: uploadDOcData
      });
      // if (uploadDOcData === 'success') {

      // }
    }
    if (AllPlansForMember !== undefined) {
      if (AllPlansForMember.records !== undefined) {
        if (AllPlansForMember.records.Small !== undefined) {
          if (AllPlansForMember.records.Small.length > 0) {
            if (AllPlansForMember1 !== AllPlansForMember) {
              this.setState({
                AllPlansForMember1: AllPlansForMember
              });
            }
          }
          // console.log("Asdsasaa",AllPlansForMember.records.Small)
        }
      }
    }
  }

  async componentWillReceiveProps(nextProps: Readonly<P>, nextContext: any): void {
    if (this.state.finalSubmitSignature === true) {
      localStorage.setItem("signInCount", "1");
      localStorage.setItem("showTutorial", true);

      // FuseBill Create Customer.
      if (
        nextProps.data.planUpdate &&
        nextProps.data.planUpdate.planName &&
        nextProps.data.planUpdate.planName !== "Basic" &&
        nextProps.data.planUpdate.planName !== "Basic Outsourced" &&
        nextProps.data.planUpdate.planName !== "Basic Automatic" &&
        nextProps.data.userInfo.roleName === "Business-User"
      ) {
        localStorage.setItem(
          "fusebillPlanFrequencyId",
          nextProps.data.planUpdate.fusebillPlanFrequencyId
        );
        localStorage.setItem("showTutorial", true);

        // const customerData = {
        //   customerInfo: {
        //     userId: nextProps.data.userInfo.userObject.userDto.userId,
        //     firstName: nextProps.data.userInfo.userObject.userDto.firstName,
        //     lastName: nextProps.data.userInfo.userObject.userDto.lastName,
        //     companyName: nextProps.data.userInfo.userObject.userDto.employer,
        //     primaryEmail: nextProps.data.userInfo.userObject.userDto.email
        //   },
        //   billing: {
        //     companyName: nextProps.data.userInfo.userObject.userDto.employer,
        //     line1: nextProps.data.userInfo.userObject.userDto.streeAddress,
        //     city: nextProps.data.userInfo.userObject.userDto.city,
        //     postalZip: nextProps.data.userInfo.userObject.userDto.zipCode,
        //     country: "USA",
        //     state: nextProps.data.userInfo.userObject.userDto.stateName
        //   }
        // };
        // nextProps.requestCreateFusebillCustomer(customerData);
        // this.setState({ createFusebillCustomerTriggered: true });
        // this.context.router.history.push("/add-payment-method");
      } else {
        localStorage.setItem("loginStatus", "success");
        this.setState({ isLoading: false });
        this.context.router.history.push("/dashboard");
      }

      this.setState({
        // createFusebillCustomerTriggered: true,
        finalSubmitSignature: false
      });
    }

    if (this.state.createPaymtMthdCalled === true) {
      let planToBasicApiData;
      let planPriceId;
      if (this.state.enterpriseType == 'E') {
        planPriceId = this.props.data.AllPlansForMember.records.Small[0]
            .planPriceDto[0].planPriceId;
      } else if (this.state.enterpriseType == 'S') {
        planPriceId = this.props.data.AllPlansForMember.records
            .Enterprise[0].planPriceDto[0].planPriceId;
      }
      planToBasicApiData = {
        userId: localStorage.getItem('userId'),
        planPriceId,
        paymentStatus: 'pending',
        selectedPlanName: 'Basic',
        selectedPlanAmount: 0,
      };
      if (
        nextProps.data.fusebillData && nextProps.data.fusebillData.addPaymentMthdError !== undefined &&
        nextProps.data.fusebillData.addPaymentMthdError !== null &&
        nextProps.data.fusebillData.addPaymentMthdError !== ""
      ) {
        if (
          nextProps.data.fusebillData.addPaymentMthdError.response.data.Errors
        ) {
          let errorMsg = "";
          nextProps.data.fusebillData.addPaymentMthdError.response.data.Errors.forEach(
            currentValue => {
              errorMsg += `${currentValue.Value} `;
            }
          );
          await this.props.planPriceChange(planToBasicApiData);
          // This parameter has been set in the localstorage because
          // there is no issue if hacker also set this param in local storage.
          // Because if he go to dashboard without payment even then he will be able to
          // access only free services.
          localStorage.setItem('paymentFailedButLetUserIn', true);
          this.setState({ createPaymtMthdCalled: false, failureModalStatus: true, isLoader: false });
          // this.recaptchaRef.current.childComponent.props.grecaptcha.reset();
        } else if (
          nextProps.data.fusebillData.addPaymentMthdError.response.data.Message
        ) {
          await this.props.planPriceChange(planToBasicApiData);
          // This parameter has been set in the localstorage because
          // there is no issue if hacker also set this param in local storage.
          // Because if he go to dashboard without payment even then he will be able to
          // access only free services.
          localStorage.setItem('paymentFailedButLetUserIn', true);
          this.setState({ createPaymtMthdCalled: false, failureModalStatus: true, isLoader: false });
          // this.recaptchaRef.current.childComponent.props.grecaptcha.reset();
        } else {
          await this.props.planPriceChange(planToBasicApiData);
          // This parameter has been set in the localstorage because
          // there is no issue if hacker also set this param in local storage.
          // Because if he go to dashboard without payment even then he will be able to
          // access only free services.
          localStorage.setItem('paymentFailedButLetUserIn', true);
          this.setState({ createPaymtMthdCalled: false, failureModalStatus: true, isLoader: false });
          // this.recaptchaRef.current.childComponent.props.grecaptcha.reset();
        }
      }
      else if (
        nextProps.data.fusebillData.fusebillCardId !== "" &&
        nextProps.data.fusebillData.fusebillCardId !== undefined &&
        nextProps.data.fusebillData.fusebillCardId !== null
        // localStorage.getItem("paymentStatus") === "pending"
      )
      {
        // Save card ID to DB.
        // Create the subscription for the customer.
        // Activate the subscription of the customer.
        // If subscription has been successfully activated.
        // Add subscription ID to DB.
        const cardInfo = {
          cardId: nextProps.data.fusebillData.fusebillCardId,
          planFrequencyId: localStorage.getItem("fusebillPlanFrequencyId"),
          userId: nextProps.data.userInfo.userObject.userDto.userId
          // paymentAmt: nextProps.data.userInfo.userObject.planPriceDtos.subscriptionFees,
        };
        nextProps.requestSaveFusebillCardId(cardInfo);
        this.setState({createPaymtMthdCalled: false, subscriptionActivated: true});
      }
    }

    if (this.state.subscriptionActivated === true) {
      // Set payment status paid.
      await localStorage.setItem("paymentStatus", "paid");
      this.setState({isLoader: false, subscriptionActivated: false, successModalStatus: true});
      localStorage.setItem("loginStatus", "success");
    }

    // if (this.state.createFusebillCustomerTriggered === true) {
    //   this.setState({ isLoading: false });
    //   if (
    //     nextProps.data.fusebillData &&
    //     nextProps.data.fusebillData.fusebillCustomerId
    //   ) {
    //     // console.log('ssssssssssssssssssss')
    //     // this.context.router.history.push("/add-payment-method");
    //   }
    //   this.setState({ createFusebillCustomerTriggered: false });
    // }

    if (this.state.basicPlanSetApiTriggered === true) {
      this.setState({basicPlanSetApiTriggered: false, isLoader: false});
      localStorage.setItem("showTutorial", true);

      this.context.router.history.push("/dashboard");
    }

    if (this.state.planBasicAndUpdateUserSignatureWithDocsApiTriggered === true && nextProps.data.uploadDOcData.success === true) {
      this.setState({planBasicAndUpdateUserSignatureWithDocsApiTriggered: false, isLoader: false});
      let data;
      let planPriceId;
      if (this.state.enterpriseType == 'S') {
        planPriceId = nextProps.data.AllPlansForMember.records.Small[0].planPriceDto[0].planPriceId;
      } else if (this.state.enterpriseType == 'E') {
        planPriceId = nextProps.data.AllPlansForMember.records.Enterprise[0].planPriceDto[0].planPriceId;
      }
      data = {
        userId: nextProps.data.userInfo.userId,
        planPriceId,
        paymentStatus: 'paid',
        selectedPlanName: 'Basic',
        selectedPlanAmount: 0,
      };
      await nextProps.planPriceChange(data);
      this.setState({basicPlanSetApiTriggered: true, isLoader: true})
    }

  }


  handleSaveData = (name, checked) => {
    let value = "";

    if (name === "readDisclaimer" && checked === true) {
      value = "1";
    }
    if (name === "readPrivacyPolicy" && checked === true) {
      value = "1";
    }
    if (name === "readLetterOfAgency" && checked === true) {
      value = "1";
    }
    if (name === "readUserAgreement" && checked === true) {
      value = "1";
    }
    if (name === "bankAccount" && checked === true) {
      value = "1";
    }
    if (name === "serviceFeeAgree" && checked === true) {
      value = "1";
    }
    this.setState({
      [name]: value
    });
    // const intervalId = setInterval(this.scrollStep.bind(this), this.props.delayInMs);
    // this.setState({ intervalId });
  };

  handleSaveDataNext = async () => {
    const { roleName, password, planName, connectFusebill } = this.state;

    await this.props.updateUserSignatureWithDocs(this.state)
    if (roleName === "Consumer") {
      await this.setState({
        cPassword: password,
        isLoader: true
      });
      await this.props.updateConsumerUser(this.state);
      await this.setState({ finalSubmitSignature: true });

      // await this.props.saveConsumerUser(this.state);
    } else if (planName === "Basic" || connectFusebill === 0) {
      await this.setState({ planBasicAndUpdateUserSignatureWithDocsApiTriggered: true, isLoader: true });
      await this.props.updateBusinessUser(this.state);
    } else {
      this.setState( prevState => ({
        tabValue: 2,
        activeTab3: true,
        recaptchaToken: "",
        cardErrors: {
          ...prevState.cardErrors,
          recaptchaTokenError: true
        }
      }));
      this.props.updateBusinessUser(this.state);
    }

    this.setState({
      legalTabFilled: true
    });

    await window.scrollTo(0, 0);
  };


  // handleSaveData = langValue => {
  //   const { roleName } = this.state;
  //   this.setState(
  //     {
  //       readDisclaimer: langValue.readDisclaimer,
  //       readPrivacyPolicy: langValue.readPrivacyPolicy,
  //       readLetterOfAgency: langValue.readLetterOfAgency,
  //       readUserAgreement: langValue.readUserAgreement,
  //       IsConusmerForm: 3
  //     },
  //     () => {
  //       this.setState({ errors: {} });
  //       if (roleName === "Consumer") {
  //         this.props.updateConsumerUser(this.state);
  //       }
  //       if (roleName === "Business-User") {
  //         this.props.updateBusinessUser(this.state);
  //       }
  //     }
  //   );

  //   const intervalId = setInterval(
  //     this.scrollStep.bind(this),
  //     this.props.delayInMs
  //   );
  //   this.setState({
  //     intervalId
  //   });
  // };

  finalSubmit = async data => {
    const {
      roleName,
      cFirstName,
      firstName,
      streeAddress,
      cLastName,
      lastName,
      cEmail,
      email
    } = this.state;
    this.setState(
      {
        file: data.file,
        firstNameFormData: roleName === "Consumer" ? cFirstName : firstName,
        lastNameFormData: roleName === "Consumer" ? cLastName : lastName,
        emailFormData: roleName === "Consumer" ? cEmail : email,
        streeAddressFomData: roleName === "Consumer" ? "" : streeAddress
      },
      () => {
        this.setState({ errors: {}, isLoading: true });
        this.setState({ finalSubmitSignature: true });
        this.AJAXTransparentRedirect()

        // this.props.updateUserSignatureWithDocs(this.state);
        // this.props.saveConsumerUser(data1);
      }
    );
  };

  backClick =() => {
      this.setState(state => ({
        tabValue: 0
      }));
    window.scrollTo(0, 0);
  }

  // backClick = () => {
  //   const { IsConusmerForm } = this.state;
  //   this.setState({
  //     IsConusmerForm: IsConusmerForm - 1
  //   });
  //   window.scrollTo(0, 0);
  // };

  topScreen = () => { };

  onItemPlanClick = (id, planName, planDetail) => {
    const {
      readUserAgreement,
      readLetterOfAgency,
      readPrivacyPolicy,
      readDisclaimer,
      fileData,
      isBussnessState
    } = this.state;
    const connectFusebill = this.props.data.AllPlansForMember && this.props.data.AllPlansForMember.connectFusebill;
    const tabValue =
      planName !== "Basic"
        ? readUserAgreement === "1" &&
          readLetterOfAgency === "1" &&
          readPrivacyPolicy === "1" &&
          readDisclaimer === "1" &&
          fileData !== ""
          ? 2
          : 1
        : 1;

    if ((planName === "Basic" && isBussnessState === false)
    || (connectFusebill === 0)) {
      this.setState({
        planId: id,
      }, () => {
        let data;
        let planPriceId;
        if (this.state.enterpriseType == 'S') {
          planPriceId = this.props.data.AllPlansForMember.records.Small[0].planPriceDto[0].planPriceId;
        } else if (this.state.enterpriseType == 'E') {
          planPriceId = this.props.data.AllPlansForMember.records.Enterprise[0].planPriceDto[0].planPriceId;
        }
        data = {
          userId: this.props.data.userInfo.userId,
          planPriceId,
          paymentStatus: 'paid',
          selectedPlanName: planName,
          selectedPlanAmount: 0,
        };
        this.props.planPriceChange(data);
        this.setState({basicPlanSetApiTriggered: true, isLoader: true})
      });
    }
    // else if(planDetail && planDetail.planPriceDto[0].connectFusebill == 0) {
    //   let planNameDto = planDetail.planName
    //   this.setState({
    //     planId: id,
    //   }, () => {
    //     let data;
    //     data = {
    //       userId: this.props.data.userInfo.userId,
    //       planPriceId:planDetail && planDetail.planPriceDto[0].planPriceId,
    //       paymentStatus: 'paid',
    //       selectedPlanName: planDetail.planName,
    //       selectedPlanAmount: planDetail &&planDetail.planPriceDto[0].subscriptionFees,
    //     };
    //     this.props.planPriceChange(data);
    //     localStorage.setItem("paymentStatus", "paid");
    //     localStorage.setItem("plainNameDto", planNameDto);
    //     this.setState({planChangeTriggered: true})
    //     this.context.router.history.push("/dashboard");
    //   });
    // }
    else {
      this.setState({
        planId: id,
        planName,
        selectedPlanName: planName,
        planPriceId:planDetail && planDetail.planPriceDto[0].planPriceId,
        fusebillPlanId:planDetail && planDetail.planPriceDto[0].fusebillPlanId,
        fusebillPlanFrequencyId:
            planDetail && planDetail.planPriceDto[0].fusebillPlanFrequencyId,
        connectFusebill:this.props.data.AllPlansForMember && this.props.data.AllPlansForMember.connectFusebill,
        activeTab3: true,
        tabValue: isBussnessState ?  tabValue : 2,
        selectedPlanAmount:planDetail &&planDetail.planPriceDto[0].subscriptionFees,
        durationData: "1 Month"
        // planPriceId: 0
      });

      window.scrollTo(0, 0);
    }
  };

  fileImage = data => {
    this.setState({
      file: data
    });
  };

  redirectToDashboard = () => {
    this.context.router.history.push(`/dashboard`)
  }

  onChangeCarad = e => {
    let labelName = e.target.name
    this.setState(
      {
        [e.target.name]: e.target.value.trimLeft()
      },
      () => {
        this.isValidCardDetail(labelName);
      }
    );
  };


  isValidCardDetail(label) {
    const { errors, errorsState , isValid } = this.validateInputCard(this.state, label);
    // console.log('errors')
    // if (!isValid) {
    this.setState({ cardErrors: errors, cardErrorsState: errorsState });
    // }
    return isValid;
  }

  validateInputCard(data, label) {
    const { cardErrorsState } = this.state;
    const errors = cardErrorsState;
    const d = new Date();

    // const scrollViews = [];
    switch(label) {

      case 'cardNumber' :
        if (Validator.isEmpty(data.cardNumber)) {
          errors.cardNumber = "Card Number is required";
          errors.cardNumberError = true;
        } else if (
          data.cardNumber.replace(/_/g, "").replace(/ /g, "").length < 15
        ) {
          errors.cardNumber = "Card Number should consist of min 15 and max 16 characters";
          errors.cardNumberError = true;
        } else {
          errors.cardNumber = "";
          errors.cardNumberError = false;
        }
      break

      case 'cardFirstName' :
        if (Validator.isEmpty(data.cardFirstName)) {
          errors.cardFirstName = "First Name is required";
          errors.cardFirstNameError = true;
        }  else if (data.cardFirstName.length < 2 || data.cardFirstName.length > 20) {
          errors.cardFirstName = 'First name should consist of min 2 and max 20 characters';
          errors.cardFirstNameError = true;
        } else {
          errors.cardFirstName = "";
          errors.cardFirstNameError = false;
        }
      break
      case 'cardLastName' :
        if (Validator.isEmpty(data.cardLastName)) {
          errors.cardLastName = "Last Name is required";
          errors.cardLastNameError = true;
        }else if (data.cardLastName.length < 2 || data.cardLastName.length > 20) {
          errors.cardLastName = 'Last name should consist of min 2 and max 20 characters';
          errors.cardLastNameError = true;
        }  else {
          errors.cardLastName = "";
          errors.cardLastNameError = false;
        }
      break
      case 'cardAddress' :
        if (Validator.isEmpty(data.cardAddress)) {
          errors.cardAddress = "Address is required";
          errors.cardAddressError = true;
        } else if (data.cardAddress.length < 2 || data.cardAddress.length > 50) {
          errors.cardAddress = 'Street address should consist of min 2 and max 50 characters ';
          errors.cardAddressError = true;
        } else {
          errors.cardAddress = "";
          errors.cardAddressError = false;
        }
       break
       case 'cardCity' :
          if (Validator.isEmpty(data.cardCity)) {
            errors.cardCity = "City is required";
            errors.cardCityError = true;
          } else if (data.cardCity.length < 2 || data.cardCity.length > 30) {
            errors.cardCity = 'City should consist of min 2 and max 30 characters';
            errors.cardCityError = true;
          } else {
            errors.cardCity = "";
            errors.cardCityError = false;
          }

         break

         case 'stateCard' :
            if (Validator.isEmpty(data.stateCard)) {
              errors.stateCard = "State is required";
              errors.stateCardError = true;
            } else {
              errors.stateCard = "";
              errors.stateCardError = false;
            }
            break

          case 'cardZipCode' :
              if (Validator.isEmpty(data.cardZipCode)) {
                errors.cardZipCode = "Zip code is required";
                errors.cardZipCodeError = true;
              } else if (
                data.cardZipCode.replace(/_/g, "").replace(/ /g, "").length < 2
              ) {
                errors.cardZipCode = "Zip code should consist of min 2 and max 5 characters";
                errors.cardZipCodeError = true;
              } else {
                errors.cardZipCode = "";
                errors.cardZipCodeError = false;
              }

            break
            case 'cardCvv' :
              if (Validator.isEmpty(data.cardCvv)) {
                errors.cardCvv = "CVV is required";
                errors.cardCvvError = true;
              } else if (
                data.cardCvv.replace(/_/g, "").length < 3 ||
                data.cardCvv.replace(/_/g, "").length > 4
              ) {
                errors.cardCvv = "CVV should consist of min 3 and max 4 characters";
                errors.cardCvvError = true;
              } else {
                errors.cardCvv = "";
                errors.cardCvvError = false;
              }
              break
              case 'cardYear' :
                  if (Validator.isEmpty(data.cardYear)) {
                    errors.cardYear = "Expiry Year is required";
                    errors.cardYearError = true;
                  } else if (data.cardYear.replace(/_/g, "").length !== 2) {
                    errors.cardYear = "Expiration Year should be equal to two numbers";
                    errors.cardYearError = true;
                    // scrollViews.push(this.expirationYearRef);
                  } else if (
                    data.cardYear.replace(/_/g, "") <
                    d
                      .getFullYear()
                      .toString()
                      .substr(-2) *
                      1
                  ) {
                    errors.cardYear = "Expiration Date must be not be in the past";
                    errors.cardYearError = true;
                  } else {
                    if (
                      data.cardYear.replace(/_/g, "").toString() ===
                      (
                        d
                          .getFullYear()
                          .toString()
                          .substr(-2) * 1
                      ).toString()
                    ) {
                    if (
                      parseInt(data.cardMonth.replace(/_/g, ""), 10) <= d.getMonth()
                    ) {
                      errors.cardMonth =
                        "Expiration Month should be equal to or greater than the current month";
                        errors.cardMonthError = true;
                    }} else {
                      errors.cardMonth = "";
                      errors.cardMonthError = false;
                    }
                    errors.cardYear = "";
                    errors.cardYearError = false;
                  }
                  if (
                    data.cardYear.replace(/_/g, "").toString() ===
                    (
                      d
                        .getFullYear()
                        .toString()
                        .substr(-2) * 1
                    ).toString()
                  ) {
                    if (
                      parseInt(data.cardMonth.replace(/_/g, ""), 10) <= d.getMonth()
                    ) {
                      errors.cardMonth =
                        "Expiration Month should be equal to or greater than the current month";
                        errors.cardMonthError = true;
                    } else {
                      errors.cardMonth = "";
                      errors.cardMonthError = false;
                    }
                  }
              break
              case 'cardMonth' :
                  if (data.cardMonth.replace(/_/g, "").length === 0) {
                    errors.cardMonth = "Month is required";
                    errors.cardMonthError = true;
                  } else if (Number.parseInt(data.cardMonth.replace(/_/g, ""), 10) <= 0 || Number.parseInt(data.cardMonth.replace(/_/g, ""), 10) > 12 ){
                    errors.cardMonth = "Month should be between 1 to 12";
                    errors.cardMonthError = true;
                  }
                  else if (
                    Number.parseInt(data.cardYear.replace(/_/g, ""), 10) ===
                    Number.parseInt( (
                      d
                        .getFullYear()
                        .toString()
                        .substr(-2) * 1
                    ).toString()
                    , 10)) {
                    if (
                      parseInt(data.cardMonth.replace(/_/g, ""), 10) <= d.getMonth()

                    ) {
                      errors.cardMonth =
                        "Expiration Month should be equal to or greater than the current month";
                        errors.cardMonthError = true;
                    } else {
                      errors.cardMonth = "";
                      errors.cardMonthError = false;
                    }
                  }
                   else {
                    errors.cardMonth = "";
                    errors.cardMonthError = false;
                  }
              break
    case '' :
    break
    case 'cardAddress2' :
    break
    case 'recaptchaToken':
        if (data.recaptchaToken !== null) {
          if (Validator.isEmpty(data.recaptchaToken)) {
            errors.recaptchaTokenError = true;
          } else {
            errors.recaptchaTokenError = false;
          }
        }
    break
       default:

          if (Validator.isEmpty(data.cardNumber)) {
            errors.cardNumber = "Card Number is required";
            errors.cardNumberError = true;
          } else if (
            data.cardNumber.replace(/_/g, "").replace(/ /g, "").length < 15
          ) {
            errors.cardNumber = "Card Number should consist of min 15 and max 16 characters";
            errors.cardNumberError = true;
          } else {
            errors.cardNumber = "";
            errors.cardNumberError = false;
          }

          if (Validator.isEmpty(data.cardFirstName)) {
            errors.cardFirstName = "First Name is required";
            errors.cardFirstNameError = true;
          }  else if (data.cardFirstName.length < 2 || data.cardFirstName.length > 20) {
            errors.cardFirstName = 'First name should consist of min 2 and max 20 characters';
            errors.cardFirstNameError = true;
          } else {
            errors.cardFirstName = "";
            errors.cardFirstNameError = false;
          }

          if (Validator.isEmpty(data.cardLastName)) {
            errors.cardLastName = "Last Name is required";
            errors.cardLastNameError = true;
          }else if (data.cardLastName.length < 2 || data.cardLastName.length > 20) {
            errors.cardLastName = 'Last name should consist of min 2 and max 20 characters';
            errors.cardLastNameError = true;
          }  else {
            errors.cardLastName = "";
            errors.cardLastNameError = false;
          }

          if (Validator.isEmpty(data.cardAddress)) {
            errors.cardAddress = "Address is required";
            errors.cardAddressError = true;
          } else if (data.cardAddress.length < 2 || data.cardAddress.length > 50) {
            errors.cardAddress = 'Street address should consist of min 2 and max 50 characters';
            errors.cardAddressError = true;
          } else {
            errors.cardAddress = "";
            errors.cardAddressError = false;
          }

          if (Validator.isEmpty(data.cardCity)) {
            errors.cardCity = "City is required";
            errors.cardCityError = true;
          } else if (data.cardCity.length < 2 || data.cardCity.length > 30) {
            errors.cardCity = 'City should consist of min 2 and max 30 characters';
            errors.cardCityError = true;
          } else {
            errors.cardCity = "";
            errors.cardCityError = false;
          }

          if (Validator.isEmpty(data.stateCard)) {
            errors.stateCard = "State is required";
            errors.stateCardError = true;
          } else {
            errors.stateCard = "";
            errors.stateCardError = false;
          }

          if (data.recaptchaToken !== null) {
            if (Validator.isEmpty(data.recaptchaToken)) {
              errors.recaptchaTokenError = true;
            } else {
              errors.recaptchaTokenError = false;
            }
          }

          if (Validator.isEmpty(data.cardZipCode)) {
            errors.cardZipCode = "Zip code is required";
            errors.cardZipCodeError = true;
          } else if (
            data.cardZipCode.replace(/_/g, "").replace(/ /g, "").length < 2
          ) {
            errors.cardZipCode = "Zip code should consist of min 2 and max 5 characters";
            errors.cardZipCodeError = true;
          } else {
            errors.cardZipCode = "";
            errors.cardZipCodeError = false;
          }


          if (data.cardMonth.replace(/_/g, "").length === 0) {
            errors.cardMonth = "Month is required";
            errors.cardMonthError = true;
          } else if (
            parseInt(data.cardMonth.replace(/_/g, ""), 10) > 12 ||
            parseInt(data.cardMonth.replace(/_/g, ""), 10) === 0
          ) {
            errors.cardMonth = "Expiry Month should be equal to two numbers";
            errors.cardMonthError = true;
          }

          if (Validator.isEmpty(data.cardCvv)) {
            errors.cardCvv = "CVV is required";
            errors.cardCvvError = true;
          } else if (
            data.cardCvv.replace(/_/g, "").length < 3 ||
            data.cardCvv.replace(/_/g, "").length > 4
          ) {
            errors.cardCvv = "CVV should consist of min 3 and max 4 characters";
            errors.cardCvvError = true;
          } else {
            errors.cardCvv = "";
            errors.cardCvvError = false;
          }

          if (Validator.isEmpty(data.cardYear)) {
            errors.cardYear = "Expiry Year is required";
            errors.cardYearError = true;
          } else if (data.cardYear.replace(/_/g, "").length !== 2) {
            errors.cardYear = "Expiration Year should be equal to two numbers";
            errors.cardYearError = true;
            // scrollViews.push(this.expirationYearRef);
          } else if (
            data.cardYear.replace(/_/g, "") <
            d
              .getFullYear()
              .toString()
              .substr(-2) *
              1
          ) {
            errors.cardYear = "Expiration Date must be not be in the past";
            errors.cardYearError = true;
          } else {
            errors.cardYear = "";
            errors.cardYearError = false;
          }

          if (
            data.cardYear.replace(/_/g, "").toString() ===
            (
              d
                .getFullYear()
                .toString()
                .substr(-2) * 1
            ).toString()
          ) {
            if (
              parseInt(data.cardMonth.replace(/_/g, ""), 10) <
              parseInt(d.getMonth().toString(), 10)
            ) {
              errors.cardMonth =
                "Expiration Month should be equal to or greater than the current month";
                errors.cardMonthError = true;
            } else {
              errors.cardMonth = "";
              errors.cardMonthError = false;
            }
          }
       break

    }

    // console.log('ssssssss',errors)

    return {
      errorsState: errors,
      errors: errors.cardNumberError === false && errors.cardFirstNameError === false && errors.cardLastNameError === false &&   errors.cardMonthError === false  && errors.cardYearError === false
      && errors.cardCvvError === false && errors.cardAddressError === false && errors.cardCityError === false && errors.stateCardError === false &&
      errors.cardZipCodeError === false && errors.recaptchaTokenError === false ? {} : errors,
      isValid: !(errors.cardNumberError === false && errors.cardFirstNameError === false && errors.cardLastNameError === false &&   errors.cardMonthError === false  && errors.cardYearError === false
        && errors.cardCvvError === false && errors.cardAddressError === false && errors.cardCityError === false && errors.stateCardError === false &&
        errors.cardZipCodeError === false && errors.recaptchaTokenError === false)
    };
  }

  selectPricePlainDetail = (
    planPriceId,
    selectedPlanAmount,
    duration,
    durationType,
    fusebillPlanId,
    fusebillPlanFrequencyId,
    connectFusebill,
    durationCheckout,
    discountCheckout
  ) => {
    this.setState(
      {
        planPriceId,
        selectedPlanAmount,
        durationData: `${durationType} ${
          duration === "Month" ? "Month" : "year"
        }`,
        fusebillPlanId,
        fusebillPlanFrequencyId,
        connectFusebill,
        durationCheckout,
        discountCheckout
      },
      () => {
        this.isValidCardDetail('');
      }
    );
  };

  cardOnChange = () => {
    const {
      sameAddress,
      firstName,
      lastName,
      streeAddress,
      city,
      zipCode,
      state,
      streeAddress2
    } = this.state;


    this.setState(
      {
        sameAddress: !sameAddress,
        cardFirstName: !sameAddress ? `${firstName}` : "",
        cardLastName: !sameAddress ? `${lastName}` : "",
        cardAddress: !sameAddress ? streeAddress : "",
        cardAddress2: !sameAddress ? streeAddress2 : "",
        cardCity: !sameAddress ? city : "",
        cardZipCode: !sameAddress ? zipCode : "",
        stateCard: !sameAddress ? state.toString() : ""
      },
      () => {
        this.isValidCardDetail();
      }
    );
  };


  _onSelectCard(e) {
    const { AllStates } = this.props.data;
    this.setState(
      {
        stateCard: e.target.value,
        stateNameCard:
        AllStates[
          AllStates.findIndex(
            data => data.stateId === parseInt(e.target.value, 10)
          )
        ] ? AllStates[
            AllStates.findIndex(
              data => data.stateId === parseInt(e.target.value, 10)
            )
          ].stateName : ''
      },
      () => {
        this.isValidCardDetail('stateCard');
      }
    );
  }


  AJAXTransparentRedirect = () => {
      this.setState({ isLoader: true });
      this.setState({ errors: {} });
      const {
        customerId,
        publicApiKey,
        cardNumber,
        makeDefault,
        recaptchaToken,
        email,
        countryId,
        stateNameCard,
        cardMonth,
        cardYear,
        cardCvv,
        cardAddress,
        cardCity,
        cardZipCode,
        cardAddress2,
        cardFirstName,
        cardLastName,
      } = this.state;
      const dataString = `CustomerId=${customerId}&PublicApiKey=${publicApiKey}&SuccessUri=${""}&FailUri=${""}&CardNumber=${cardNumber
        .replace(/_/g, "")
        .replace(
          / /g,
          ""
        )}&FirstName=${cardFirstName}&LastName=${cardLastName}&ExpirationMonth=${cardMonth.replace(
          /_/g,
          ""
        )}&ExpirationYear=${cardYear.replace(
          /_/g,
          ""
        )}&makeDefault=${makeDefault}&Cvv=${cardCvv.replace(
          /_/g,
          ""
        )}&email=${email}&address1=${cardAddress}&address2=${cardAddress2}&city=${cardCity}&state=${stateNameCard}&country=${countryId}&postalZip=${cardZipCode}&recaptcha=${recaptchaToken}`;
      this.props.requestSaveFusebillPaymentMethod({ dataString, postdata: this.state });
      this.setState({ createPaymtMthdCalled: true });
  };

  onReCaptchaChange = value => {
    this.setState({ recaptchaToken: value }, () => {
      this.isValidCardDetail('recaptchaToken');
    });
  };

  render() {
    // const {
    //   IsConusmerForm, enterpriseType, totalTaxId, AllPlansForMember1, isLoading, signatureDefaultValue, signatureFontFamily, enableButtonT,
    // } = this.state;

    const {
      // IsConusmerForm,
      // isLoading,
      stateCard,
      planPriceId,
      // IsSignatureForm,
      file,
      signatureDefaultValue,
      signatureFontFamily,
      // enableButtonT,
      readDisclaimer,
      readUserAgreement,
      readPrivacyPolicy,
      readLetterOfAgency,
      planName,
      planId,
      cardErrors,
      cardNumber,
      cardFirstName,
      cardLastName,

      durationData,
      selectedPlanAmount,
      showTab,
      defaultIndex,
      activePlanForBussness,
      showplanDetail,

      cardMonth,
      cardYear,
      cardCvv,
      cardAddress,
      cardAddress2,
      cardCity,
      cardZipCode,
      sameAddress,
      showTabPlan,
      showTabPlan1,
      showTabPlan2,
      showTabPlan3,
      showTabPlan4,
      showTabPlan5,

      // recaptchaToken,
      // fusebillPlanId,
      // fusebillPlanFrequencyId,
      connectFusebill,

      successModalStatus,
      durationCheckout,
      discountCheckout,
      tabValueConsumer,
      tabValue,
      isLoader,
      isLoaderDataSave,
      enterpriseType,
      totalTaxId,
      isBussnessState,
      failureModalStatus,
    } = this.state;
    // const {
    //   userObject,
    //   // enterpriseType,
    //   // totalTaxId
    // } = this.props.data.userInfo;

    const { AllPlansForMember,       plansDataAffiliate,
      AllStates
    } = this.props.data;


    if (this.props.data
        && this.props.data.userInfo
        && this.props.data.userInfo.userObject
        && this.props.data.userInfo.userObject.userDto) {
      const userDto = this.props.data.userInfo.userObject.userDto;
    }

    const options = [];
    options.push(
      <option key={0} value="">
        State
      </option>
    );
    AllStates.map(item =>
      // return options.push({value: item.stateId, label: item.stateName, name: item.stateName})
      options.push(
        <option key={item.stateId} value={item.stateId}>
          {item.stateName}
        </option>
      )
    );

    let tabs;
    // console.log('ssssssssssssssssssss', partnerType, showTab)
    //  if (showTab === 1) {
      tabs = (
        <div style={{ display: "block" }}>
          <Tab className="tab col s6">
            <a className=''>I'm a consumer</a>
          </Tab>
          <Tab className="tab col s6">
            <a className=''>I'm a business representative</a>
          </Tab>
        </div>
      );
    // }

    let loader1;
    if (isLoader) {
      loader1 = (
        <div className="loader">
          <img src={loader} alt="" />
        </div>
      );
    }
    if (isLoaderDataSave) {
      loader1 = (
        <div className="loader">
          <img src={loader} alt="" />
        </div>
      );
    }

    return (
      <div id="wrapper">
        <Modal
            isOpen={successModalStatus}
            onAfterOpen={this.afterOpenModal}
            onRequestClose={this.closeModalSuccess}
            style={customStyles}
            contentLabel='test'
            ariaHideApp={false}
            // className="welcome-modal"
        >
          <div className='signup-signature welcome-modal center-align'>
            <div className='tick-success'>
              <i className='medium material-icons'>check</i>
            </div>

            <h4>Payment Success</h4>
            <p>Thank you for your payment.</p>
            <p>Visit your dashboard to get started.</p>

            <Link className='btn-blue remove-trasformation' to='/dashboard'>
              Go to my dashboard
            </Link>
          </div>
        </Modal>
        <Modal
            isOpen={failureModalStatus}
            onAfterOpen={this.afterOpenModal}
            onRequestClose={this.closeModalSuccess}
            style={customStyles}
            contentLabel='test'
            ariaHideApp={false}
            // className="welcome-modal"
        >
          <div className='signup-signature welcome-modal center-align'>
            <div className='tick-failure'>
              <i className='medium material-icons'>close</i>
            </div>

            <h4>Payment Failed</h4>
            <p>
              <Linkify>Please follow {''}
                <a href={this.state.zendeskLink}>
                this link
                </a>{''} to contact administrator.
              </Linkify>
            </p>

            <Link className='btn-blue remove-trasformation' to='/dashboard'>
              Go to my dashboard
            </Link>
          </div>
        </Modal>
      {loader1}
        <div className="container custom-container">
          <header className="section">
            <div className="logo center-align">
              <Link to="/">
                <img className="responsive-img" src={logoImage} alt="" />
              </Link>
            </div>
          </header>
          <div className="signup-m2">
            <Tabs
              selectedIndex={defaultIndex}
              className="react-tabs-form"
              onSelect={defaultIndex1 =>
                this.setState(
                  {
                    defaultIndex: defaultIndex1,
                    isConsumer: defaultIndex1 !== 1
                  },
                  () => {
                    defaultIndex1 === 1
                      ? this.props.getPageDataFooter(7)
                      : this.props.getPageDataFooter(6);
                    this.props.clearDataEmail();
                    localStorage.clear();
                    this.props.clearSignupData();
                    localStorage.setItem(
                      "userTypeFooter",
                      defaultIndex1 === 1 ? "Business-User" : "Consumer"
                    );
                  }
                )
              }
            >
              <TabList
                id="tabs-swipe-demo"
                style={{ display: showTab === 1 ? "none" : "none" }}
                className="tabs"
              >
                {tabs}
              </TabList>
              <TabPanel>
                <Tabs
                  className="react-tabs-form-bussness"
                  selectedIndex={tabValueConsumer}
                  onSelect={newValue => {
                    this.setState({
                      tabValueConsumer: newValue
                    });
                  }}
                >
                  <div className="row consumer-tab-info ibmfont signup-new-tabs ">
                    <div className="col s12">
                      <TabList>
                        <Tab>
                          1. LEGAL{" "}
                        </Tab>
                      </TabList>
                    </div>
                    <div className="clear left col s12">
                     <TabPanel>
                        <TermAndCondition
                          termsAndConditionData={this.handleSaveData}
                          termsAndConditionDataNextPage={
                            this.handleSaveDataNext
                          }
                          termsAndConditionBack={this.backClick}
                          readDisclaimer={readDisclaimer}
                          readUserAgreement={readUserAgreement}
                          readPrivacyPolicy={readPrivacyPolicy}
                          readLetterOfAgency={readLetterOfAgency}
                          pageType="consumer"
                          backButton
                          signupData={this.state}
                          defaultValue={signatureDefaultValue}
                          fontFamily={signatureFontFamily}
                          // finalSubmitData={this.finalSubmit}
                          fileImage={this.fileImage}
                          moveTop={this.topScreen}
                          fileData={file}
                          hide
                          isConsumer
                          hideBack
                        />
                      </TabPanel>
                    </div>
                  </div>
                </Tabs>
              </TabPanel>

              <TabPanel className="active ">
                <Tabs
                  className="react-tabs-form-bussness"
                  selectedIndex={tabValue}
                  onSelect={newValue => {
                    console.log('newValue',newValue)
                    this.setState(prevState => ({
                      tabValue: newValue,
                      recaptchaToken: "",
                      cardErrors: {
                        ...prevState.cardErrors,
                        recaptchaTokenError: true
                      }
                    }));
                  }}
                  // this.setState( prevState => ({
                  //   cardErrors: {
                  //     ...prevState.cardErrors,
                  //     recaptchaTokenError: true
                  //   }}
                >
                  <div className="row ibmfont signup-new-tabs">
                    <div className="col s12 list-count-cursor">
                      <TabList aria-label="simple tabs example">
                        <Tab>
                          {" "}
                          <span className=""> 1.</span> Pick A Plan{" "}
                        </Tab>
                        {
                          isBussnessState ? <Tab
                              // className= {isBussnessState ? "" : "hide-tab" }
                              disabled={
                                planId === ""

                              }
                          >
                            {" "}
                            <span className=""> 2.</span> Legal
                          </Tab> : ''
                        }

                        {console.log('connectFusebill',this.props.data.AllPlansForMember && this.props.data.AllPlansForMember.connectFusebill)}
                        <Tab
                            disabled={
                              !(
                                  planId !== "" &&
                                  readUserAgreement === "1" &&
                                  readLetterOfAgency === "1" &&
                                  readPrivacyPolicy === "1" &&
                                  readDisclaimer === "1" &&
                                  file !== "" &&
                                  planName !== "" &&
                                  selectedPlanAmount !== ""
                              )
                            }
                            className={
                              planName === "Basic" || connectFusebill === 0
                                  ? "hide-tab-info list-count-cursor"
                                  : !(
                                      planId !== "" &&
                                      readUserAgreement === "1" &&
                                      readLetterOfAgency === "1" &&
                                      readPrivacyPolicy === "1" &&
                                      readDisclaimer === "1" &&
                                      file !== "" &&
                                      planName !== "" &&
                                      selectedPlanAmount !== ""
                                  ) ? "" : "list-count-cursor"
                            }
                        >



                          <span className="">
                            {/* {this.props.data.AllPlansForMember && this.props.data.AllPlansForMember.connectFusebill != 0 ? isBussnessState ? '3.' : '2.' : ""} */}
                            {this.props.data.AllPlansForMember && this.props.data.AllPlansForMember.connectFusebill == 0 ? "" : isBussnessState ? '3.' : '2.' }
                          </span>
                          {this.props.data.AllPlansForMember && this.props.data.AllPlansForMember.connectFusebill == 0 ? "" : "Checkout"}
                        </Tab>


                      </TabList>
                    </div>
                    {console.log('connectFusebill', this.state.connectFusebill)}
                    <div className="clear left col s12">
                      <TabPanel>
                        <div className="d-flex  plan-outer pick-a-plan">
                          <div
                            id="additional-tab"
                            className=" plans-outer plans-new-signup ibmfont"
                          >
                            <div className="pick-plan-outer">
                              <p className="center-align choose-plan-type">
                                Choose the type of plan you want:
                              </p>
                              <div className="pick-plan-btn-outer">
                                <button
                                  type="submit"
                                  name="action"
                                  onClick={() => {
                                    this.setState({
                                      activePlanForBussness: "Premium"
                                    });
                                  }}
                                  className={
                                    activePlanForBussness === "Premium"
                                      ? " waves-effect waves-light btn-small ltblue-btn text-700"
                                      : "waves-effect waves-light btn-small white-btn text-700"
                                  }
                                >
                                  Claims filed automatically
                                </button>
                                <span className="or">or</span>
                                <button
                                  onClick={() => {
                                    this.setState({
                                      activePlanForBussness: "flex"
                                    });
                                  }}
                                  className={
                                    activePlanForBussness === "flex"
                                      ? " waves-effect waves-light btn-small ltblue-btn text-700"
                                      : "waves-effect waves-light btn-small white-btn text-700"
                                  }
                                  type="submit"
                                  name="action"
                                >
                                  I want to be more hands-on
                                </button>
                              </div>
                              <h6 className="center-align best-plan-hdr">
                                Select the best plan for you:
                              </h6>
                            </div>

                            {enterpriseType === "S" ? (
                              <div className=" plan-flex">
                                <div
                                  className={
                                    activePlanForBussness === "Premium"
                                      ? "step-3"
                                      : "step-3 disabled-plan-page"
                                  }
                                >
                                  <div className="plan-one">
                                    <h5 className="text-uppercase text-700 signup-title">
                                      {this.props.match.params
                                        .affiliateKey === undefined
                                        ? AllPlansForMember &&
                                          AllPlansForMember.records &&
                                          AllPlansForMember.records.Small &&
                                          AllPlansForMember.records
                                            .Small[0] &&
                                          AllPlansForMember.records.Small[0]
                                            .planName
                                        : plansDataAffiliate &&
                                          plansDataAffiliate.result &&
                                          plansDataAffiliate.result
                                            .affiliateSubscriptionDto &&
                                          plansDataAffiliate.result
                                            .affiliateSubscriptionDto.map &&
                                          plansDataAffiliate.result
                                            .affiliateSubscriptionDto.map
                                            .Small &&
                                          plansDataAffiliate.result
                                            .affiliateSubscriptionDto.map
                                            .Small[0]
                                        ? plansDataAffiliate &&
                                          plansDataAffiliate.result &&
                                          plansDataAffiliate.result
                                            .affiliateSubscriptionDto &&
                                          plansDataAffiliate.result
                                            .affiliateSubscriptionDto.map &&
                                          plansDataAffiliate.result
                                            .affiliateSubscriptionDto.map
                                            .Small &&
                                          plansDataAffiliate.result
                                            .affiliateSubscriptionDto.map
                                            .Small[0].planName
                                        : ""}
                                    </h5>
                                    <h5 className="signup-title2">
                                      No Upfront Cost
                                    </h5>
                                    <p className="plan-small-font">
                                      Collectively keeps{" "}
                                      <b>
                                        {" "}
                                        {this.props.match.params
                                          .affiliateKey === undefined
                                          ? AllPlansForMember &&
                                            AllPlansForMember.records &&
                                            AllPlansForMember.records.Small &&
                                            AllPlansForMember.records
                                              .Small[0] &&
                                            AllPlansForMember.records.Small[0]
                                              .planPriceDto[0] &&
                                            AllPlansForMember.records.Small[0].planPriceDto[0].fundCommission.toFixed(
                                              2
                                            )
                                          : plansDataAffiliate &&
                                            plansDataAffiliate.result &&
                                            plansDataAffiliate.result
                                              .affiliateSubscriptionDto &&
                                            plansDataAffiliate.result
                                              .affiliateSubscriptionDto.map &&
                                            plansDataAffiliate.result
                                              .affiliateSubscriptionDto.map
                                              .Small &&
                                            plansDataAffiliate.result
                                              .affiliateSubscriptionDto.map
                                              .Small[0].planPriceDto[0] &&
                                            plansDataAffiliate.result.affiliateSubscriptionDto.map.Small[0].planPriceDto[0].fundCommission.toFixed(
                                              2
                                            )}
                                        %{" "}
                                      </b>{" "}
                                      of collected funds
                                    </p>
                                    <p className="font-medium forcompany-web forcompany-mob">
                                      For companies that want to try out
                                      Collectively
                                    </p>
                                    <button
                                      onClick={() =>
                                        this.props.match.params
                                          .affiliateKey === undefined
                                          ? this.onItemPlanClick(
                                              AllPlansForMember &&
                                                AllPlansForMember.records &&
                                                AllPlansForMember.records
                                                  .Small &&
                                                AllPlansForMember.records
                                                  .Small[0]
                                                ? AllPlansForMember.records
                                                    .Small[0].planId
                                                : "",

                                              AllPlansForMember &&
                                                AllPlansForMember.records &&
                                                AllPlansForMember.records
                                                  .Small &&
                                                AllPlansForMember.records
                                                  .Small[0]
                                                ? AllPlansForMember.records
                                                    .Small[0].planName
                                                : "",

                                              AllPlansForMember &&
                                                AllPlansForMember.records &&
                                                AllPlansForMember.records
                                                  .Small &&
                                                AllPlansForMember.records
                                                  .Small[0]
                                                ? AllPlansForMember.records
                                                    .Small[0]
                                                : ""
                                            )
                                          : this.onItemPlanClick(
                                              plansDataAffiliate &&
                                                plansDataAffiliate.result &&
                                                plansDataAffiliate.result
                                                  .affiliateSubscriptionDto &&
                                                plansDataAffiliate.result
                                                  .affiliateSubscriptionDto
                                                  .map &&
                                                plansDataAffiliate.result
                                                  .affiliateSubscriptionDto
                                                  .map.Small &&
                                                plansDataAffiliate.result
                                                  .affiliateSubscriptionDto
                                                  .map.Small[0]
                                                ? plansDataAffiliate.result
                                                    .affiliateSubscriptionDto
                                                    .map.Small[0].planId
                                                : "",
                                              plansDataAffiliate &&
                                                plansDataAffiliate.result &&
                                                plansDataAffiliate.result
                                                  .affiliateSubscriptionDto &&
                                                plansDataAffiliate.result
                                                  .affiliateSubscriptionDto
                                                  .map &&
                                                plansDataAffiliate.result
                                                  .affiliateSubscriptionDto
                                                  .map.Small &&
                                                plansDataAffiliate.result
                                                  .affiliateSubscriptionDto
                                                  .map.Small[0]
                                                ? plansDataAffiliate &&
                                                    plansDataAffiliate.result &&
                                                    plansDataAffiliate.result
                                                      .affiliateSubscriptionDto &&
                                                    plansDataAffiliate.result
                                                      .affiliateSubscriptionDto
                                                      .map &&
                                                    plansDataAffiliate.result
                                                      .affiliateSubscriptionDto
                                                      .map.Small &&
                                                    plansDataAffiliate.result
                                                      .affiliateSubscriptionDto
                                                      .map.Small[0].planName
                                                : "",
                                              plansDataAffiliate &&
                                                plansDataAffiliate.result &&
                                                plansDataAffiliate.result
                                                  .affiliateSubscriptionDto &&
                                                plansDataAffiliate.result
                                                  .affiliateSubscriptionDto
                                                  .map &&
                                                plansDataAffiliate.result
                                                  .affiliateSubscriptionDto
                                                  .map.Small &&
                                                plansDataAffiliate.result
                                                  .affiliateSubscriptionDto
                                                  .map.Small[0]
                                                ? plansDataAffiliate &&
                                                    plansDataAffiliate.result &&
                                                    plansDataAffiliate.result
                                                      .affiliateSubscriptionDto &&
                                                    plansDataAffiliate.result
                                                      .affiliateSubscriptionDto
                                                      .map &&
                                                    plansDataAffiliate.result
                                                      .affiliateSubscriptionDto
                                                      .map.Small &&
                                                    plansDataAffiliate.result
                                                      .affiliateSubscriptionDto
                                                      .map.Small[0]
                                                : ""
                                            )
                                      }
                                      className={
                                        this.props.match.params
                                          .affiliateKey === undefined
                                          ? AllPlansForMember &&
                                            AllPlansForMember.records &&
                                            AllPlansForMember.records.Small &&
                                            AllPlansForMember.records
                                              .Small[0] &&
                                            AllPlansForMember.records.Small[0]
                                              .planId === planId
                                            ? "waves-effect waves-light btn-small pink-btn"
                                            : "waves-effect waves-light btn-small white-btn"
                                          : plansDataAffiliate &&
                                            plansDataAffiliate.result &&
                                            plansDataAffiliate.result
                                              .affiliateSubscriptionDto &&
                                            plansDataAffiliate.result
                                              .affiliateSubscriptionDto.map &&
                                            plansDataAffiliate.result
                                              .affiliateSubscriptionDto.map
                                              .Small &&
                                            plansDataAffiliate.result
                                              .affiliateSubscriptionDto.map
                                              .Small[0] &&
                                            plansDataAffiliate.result
                                              .affiliateSubscriptionDto.map
                                              .Small[0].planId === planId
                                          ? "waves-effect waves-light btn-small pink-btn"
                                          : "waves-effect waves-light btn-small white-btn"
                                      }
                                    >
                                      Select Plan
                                    </button>
                                    <div
                                      className={
                                        showTabPlan5
                                          ? "list-collapse d-list"
                                          : "list-collapse"
                                      }
                                    >
                                      <ul>
                                        <li>
                                          VISA/Mastercard claim included
                                        </li>
                                        <li>
                                          File upto 10 claims per entity{" "}
                                          <sup>2</sup>
                                        </li>
                                        <li>
                                          We collect claim forms for all
                                          entities
                                        </li>
                                        <li>
                                          Personalized dashboard and
                                          settlement alerts
                                        </li>
                                        <li>Upgrade at anytime</li>
                                      </ul>
                                    </div>
                                    <div
                                      className="link-collapse"
                                      onClick={() => {
                                        this.setState({
                                          showTabPlan5: !showTabPlan5
                                        });
                                      }}
                                    >
                                      {showTabPlan5
                                        ? "Show less"
                                        : "Show more"}

                                      <span className="down-arrow">
                                        {" "}
                                        <i
                                          className={
                                            showTabPlan5
                                              ? "material-icons angle-transposne"
                                              : " material-icons"
                                          }
                                        >
                                          expand_more
                                        </i>
                                      </span>
                                    </div>
                                  </div>
                                </div>
                                <div
                                  className={
                                    activePlanForBussness === "Premium"
                                      ? "step-3"
                                      : "col m4  step-3 disabled-plan-page"
                                  }
                                >
                                  <div className="plan-one premium-plan">
                                    <span className="best-value text-700 text-uppercase">
                                      Best value
                                    </span>
                                    <h5 className="text-uppercase text-700 signup-title text-pink">
                                      {this.props.match.params
                                        .affiliateKey === undefined
                                        ? AllPlansForMember &&
                                          AllPlansForMember.records &&
                                          AllPlansForMember.records.Small &&
                                          AllPlansForMember.records
                                            .Small[1] &&
                                          AllPlansForMember.records.Small[1]
                                            .planName
                                        : plansDataAffiliate &&
                                          plansDataAffiliate.result &&
                                          plansDataAffiliate.result
                                            .affiliateSubscriptionDto &&
                                          plansDataAffiliate.result
                                            .affiliateSubscriptionDto.map &&
                                          plansDataAffiliate.result
                                            .affiliateSubscriptionDto.map
                                            .Small &&
                                          plansDataAffiliate.result
                                            .affiliateSubscriptionDto.map
                                            .Small[1]
                                        ? plansDataAffiliate &&
                                          plansDataAffiliate.result &&
                                          plansDataAffiliate.result
                                            .affiliateSubscriptionDto &&
                                          plansDataAffiliate.result
                                            .affiliateSubscriptionDto.map &&
                                          plansDataAffiliate.result
                                            .affiliateSubscriptionDto.map
                                            .Small &&
                                          plansDataAffiliate.result
                                            .affiliateSubscriptionDto.map
                                            .Small[1].planName
                                        : ""}
                                    </h5>
                                    <h5 className="signup-title2">
                                      $
                                      {this.props.match.params
                                        .affiliateKey === undefined
                                        ? AllPlansForMember &&
                                          AllPlansForMember.records &&
                                          AllPlansForMember.records.Small &&
                                          AllPlansForMember.records
                                            .Small[1] &&
                                          AllPlansForMember.records.Small[1]
                                            .planPriceDto[0] &&
                                          AllPlansForMember.records.Small[1].planPriceDto[0].subscriptionFees.toFixed(
                                            2
                                          )
                                        : plansDataAffiliate &&
                                          plansDataAffiliate.result &&
                                          plansDataAffiliate.result
                                            .affiliateSubscriptionDto &&
                                          plansDataAffiliate.result
                                            .affiliateSubscriptionDto.map &&
                                          plansDataAffiliate.result
                                            .affiliateSubscriptionDto.map
                                            .Small &&
                                          plansDataAffiliate.result
                                            .affiliateSubscriptionDto.map
                                            .Small[1].planPriceDto[0] &&
                                          plansDataAffiliate.result.affiliateSubscriptionDto.map.Small[1].planPriceDto[0].subscriptionFees.toFixed(
                                            2
                                          )}
                                      /month <sup>1</sup>
                                    </h5>
                                    <p className="plan-small-font">
                                      Collectively keeps{" "}
                                      <b>
                                        {" "}
                                        {this.props.match.params
                                          .affiliateKey === undefined
                                          ? AllPlansForMember &&
                                            AllPlansForMember.records &&
                                            AllPlansForMember.records.Small &&
                                            AllPlansForMember.records
                                              .Small[1] &&
                                            AllPlansForMember.records.Small[1]
                                              .planPriceDto[0] &&
                                            AllPlansForMember.records.Small[1].planPriceDto[0].fundCommission.toFixed(
                                              2
                                            )
                                          : plansDataAffiliate &&
                                            plansDataAffiliate.result &&
                                            plansDataAffiliate.result
                                              .affiliateSubscriptionDto &&
                                            plansDataAffiliate.result
                                              .affiliateSubscriptionDto.map &&
                                            plansDataAffiliate.result
                                              .affiliateSubscriptionDto.map
                                              .Small &&
                                            plansDataAffiliate.result
                                              .affiliateSubscriptionDto.map
                                              .Small[0].planPriceDto[0] &&
                                            plansDataAffiliate.result.affiliateSubscriptionDto.map.Small[1].planPriceDto[0].fundCommission.toFixed(
                                              2
                                            )}{" "}
                                        %{" "}
                                      </b>{" "}
                                      of collected funds
                                    </p>
                                    <p className="font-medium forcompany-web forcompany-mob">
                                      For companies that want claims filed
                                      automatically
                                    </p>
                                    <button
                                      onClick={() =>
                                        this.props.match.params
                                          .affiliateKey === undefined
                                          ? this.onItemPlanClick(
                                              AllPlansForMember &&
                                                AllPlansForMember.records &&
                                                AllPlansForMember.records
                                                  .Small &&
                                                AllPlansForMember.records
                                                  .Small[1]
                                                ? AllPlansForMember.records
                                                    .Small[1].planId
                                                : "",

                                              AllPlansForMember &&
                                                AllPlansForMember.records &&
                                                AllPlansForMember.records
                                                  .Small &&
                                                AllPlansForMember.records
                                                  .Small[1]
                                                ? AllPlansForMember.records
                                                    .Small[1].planName
                                                : "",

                                              AllPlansForMember &&
                                                AllPlansForMember.records &&
                                                AllPlansForMember.records
                                                  .Small &&
                                                AllPlansForMember.records
                                                  .Small[1]
                                                ? AllPlansForMember.records
                                                    .Small[1]
                                                : ""
                                            )
                                          : this.onItemPlanClick(
                                              plansDataAffiliate &&
                                                plansDataAffiliate.result &&
                                                plansDataAffiliate.result
                                                  .affiliateSubscriptionDto &&
                                                plansDataAffiliate.result
                                                  .affiliateSubscriptionDto
                                                  .map &&
                                                plansDataAffiliate.result
                                                  .affiliateSubscriptionDto
                                                  .map.Small &&
                                                plansDataAffiliate.result
                                                  .affiliateSubscriptionDto
                                                  .map.Small[1]
                                                ? plansDataAffiliate.result
                                                    .affiliateSubscriptionDto
                                                    .map.Small[1].planId
                                                : "",
                                              plansDataAffiliate &&
                                                plansDataAffiliate.result &&
                                                plansDataAffiliate.result
                                                  .affiliateSubscriptionDto &&
                                                plansDataAffiliate.result
                                                  .affiliateSubscriptionDto
                                                  .map &&
                                                plansDataAffiliate.result
                                                  .affiliateSubscriptionDto
                                                  .map.Small &&
                                                plansDataAffiliate.result
                                                  .affiliateSubscriptionDto
                                                  .map.Small[1]
                                                ? plansDataAffiliate &&
                                                    plansDataAffiliate.result &&
                                                    plansDataAffiliate.result
                                                      .affiliateSubscriptionDto &&
                                                    plansDataAffiliate.result
                                                      .affiliateSubscriptionDto
                                                      .map &&
                                                    plansDataAffiliate.result
                                                      .affiliateSubscriptionDto
                                                      .map.Small &&
                                                    plansDataAffiliate.result
                                                      .affiliateSubscriptionDto
                                                      .map.Small[1].planName
                                                : "",
                                              plansDataAffiliate &&
                                                plansDataAffiliate.result &&
                                                plansDataAffiliate.result
                                                  .affiliateSubscriptionDto &&
                                                plansDataAffiliate.result
                                                  .affiliateSubscriptionDto
                                                  .map &&
                                                plansDataAffiliate.result
                                                  .affiliateSubscriptionDto
                                                  .map.Small &&
                                                plansDataAffiliate.result
                                                  .affiliateSubscriptionDto
                                                  .map.Small[0]
                                                ? plansDataAffiliate &&
                                                    plansDataAffiliate.result &&
                                                    plansDataAffiliate.result
                                                      .affiliateSubscriptionDto &&
                                                    plansDataAffiliate.result
                                                      .affiliateSubscriptionDto
                                                      .map &&
                                                    plansDataAffiliate.result
                                                      .affiliateSubscriptionDto
                                                      .map.Small &&
                                                    plansDataAffiliate.result
                                                      .affiliateSubscriptionDto
                                                      .map.Small[1]
                                                : ""
                                            )
                                      }
                                      className={
                                        this.props.match.params
                                          .affiliateKey === undefined
                                          ? AllPlansForMember &&
                                            AllPlansForMember.records &&
                                            AllPlansForMember.records.Small &&
                                            AllPlansForMember.records
                                              .Small[1] &&
                                            AllPlansForMember.records.Small[1]
                                              .planId === planId
                                            ? "waves-effect waves-light btn-small pink-btn"
                                            : "waves-effect waves-light btn-small white-btn"
                                          : plansDataAffiliate &&
                                            plansDataAffiliate.result &&
                                            plansDataAffiliate.result
                                              .affiliateSubscriptionDto &&
                                            plansDataAffiliate.result
                                              .affiliateSubscriptionDto.map &&
                                            plansDataAffiliate.result
                                              .affiliateSubscriptionDto.map
                                              .Small &&
                                            plansDataAffiliate.result
                                              .affiliateSubscriptionDto.map
                                              .Small[1] &&
                                            plansDataAffiliate.result
                                              .affiliateSubscriptionDto.map
                                              .Small[1].planId === planId
                                          ? "waves-effect waves-light btn-small pink-btn"
                                          : "waves-effect waves-light btn-small white-btn"
                                      }
                                    >
                                      Select Plan
                                    </button>
                                    <div
                                      className={
                                        showTabPlan4
                                          ? "list-collapse d-list"
                                          : "list-collapse"
                                      }
                                    >
                                      <ul>
                                        <li>
                                          Claims filed automatically
                                          <sup>2</sup>
                                        </li>
                                        <li>Unlimited claim filings</li>
                                        <li>
                                          We collect claim forms for all
                                          entities
                                        </li>
                                        <li>
                                          Personalized dashboard and
                                          settlement alerts
                                        </li>
                                        <li>
                                          {" "}
                                          Each additional EIN is +$1.00/month
                                          <br /> (capped at $250/month)
                                        </li>
                                      </ul>
                                    </div>
                                    <div
                                      className="link-collapse"
                                      onClick={() => {
                                        this.setState({
                                          showTabPlan4: !showTabPlan4
                                        });
                                      }}
                                    >
                                      {showTabPlan4
                                        ? "Show less"
                                        : "Show more"}

                                      <span className="down-arrow">
                                        {" "}
                                        <i
                                          className={
                                            showTabPlan4
                                              ? "material-icons angle-transposne"
                                              : " material-icons"
                                          }
                                        >
                                          expand_more
                                        </i>
                                      </span>
                                    </div>
                                  </div>
                                </div>
                                <div
                                  className={
                                    activePlanForBussness === "flex"
                                      ? "step-3"
                                      : "step-3 disabled-plan-page"
                                  }
                                >
                                  <div className="plan-one premium-plan">
                                    <h5 className="text-uppercase text-700 signup-title">
                                      {this.props.match.params
                                        .affiliateKey === undefined
                                        ? AllPlansForMember &&
                                          AllPlansForMember.records &&
                                          AllPlansForMember.records.Small &&
                                          AllPlansForMember.records
                                            .Small[2] &&
                                          AllPlansForMember.records.Small[2]
                                            .planName
                                        : plansDataAffiliate &&
                                          plansDataAffiliate.result &&
                                          plansDataAffiliate.result
                                            .affiliateSubscriptionDto &&
                                          plansDataAffiliate.result
                                            .affiliateSubscriptionDto.map &&
                                          plansDataAffiliate.result
                                            .affiliateSubscriptionDto.map
                                            .Small &&
                                          plansDataAffiliate.result
                                            .affiliateSubscriptionDto.map
                                            .Small[2]
                                        ? plansDataAffiliate &&
                                          plansDataAffiliate.result &&
                                          plansDataAffiliate.result
                                            .affiliateSubscriptionDto &&
                                          plansDataAffiliate.result
                                            .affiliateSubscriptionDto.map &&
                                          plansDataAffiliate.result
                                            .affiliateSubscriptionDto.map
                                            .Small &&
                                          plansDataAffiliate.result
                                            .affiliateSubscriptionDto.map
                                            .Small[2].planName
                                        : ""}
                                    </h5>
                                    <h5 className="signup-title2 text-pink">
                                      $
                                      {this.props.match.params
                                        .affiliateKey === undefined
                                        ? AllPlansForMember &&
                                          AllPlansForMember.records &&
                                          AllPlansForMember.records.Small &&
                                          AllPlansForMember.records
                                            .Small[2] &&
                                          AllPlansForMember.records.Small[2]
                                            .planPriceDto[0] &&
                                          AllPlansForMember.records.Small[2].planPriceDto[0].subscriptionFees.toFixed(
                                            2
                                          )
                                        : plansDataAffiliate &&
                                          plansDataAffiliate.result &&
                                          plansDataAffiliate.result
                                            .affiliateSubscriptionDto &&
                                          plansDataAffiliate.result
                                            .affiliateSubscriptionDto.map &&
                                          plansDataAffiliate.result
                                            .affiliateSubscriptionDto.map
                                            .Small &&
                                          plansDataAffiliate.result
                                            .affiliateSubscriptionDto.map
                                            .Small[0].planPriceDto[0] &&
                                          plansDataAffiliate.result.affiliateSubscriptionDto.map.Small[2].planPriceDto[0].subscriptionFees.toFixed(
                                            2
                                          )}
                                      /month <sup>1</sup>
                                    </h5>
                                    <p className="plan-small-font">
                                      Collectively keeps{" "}
                                      <b>
                                        {" "}
                                        {this.props.match.params
                                          .affiliateKey === undefined
                                          ? AllPlansForMember &&
                                            AllPlansForMember.records &&
                                            AllPlansForMember.records.Small &&
                                            AllPlansForMember.records
                                              .Small[2] &&
                                            AllPlansForMember.records.Small[2]
                                              .planPriceDto[0] &&
                                            AllPlansForMember.records.Small[2].planPriceDto[0].fundCommission.toFixed(
                                              2
                                            )
                                          : plansDataAffiliate &&
                                            plansDataAffiliate.result &&
                                            plansDataAffiliate.result
                                              .affiliateSubscriptionDto &&
                                            plansDataAffiliate.result
                                              .affiliateSubscriptionDto.map &&
                                            plansDataAffiliate.result
                                              .affiliateSubscriptionDto.map
                                              .Small &&
                                            plansDataAffiliate.result
                                              .affiliateSubscriptionDto.map
                                              .Small[0].planPriceDto[0] &&
                                            plansDataAffiliate.result.affiliateSubscriptionDto.map.Small[2].planPriceDto[0].fundCommission.toFixed(
                                              2
                                            )}
                                        %{" "}
                                      </b>{" "}
                                      of collected funds
                                    </p>
                                    <p className="forcompany-web forcompany-mob">
                                      For companies that want to be more hands
                                      on
                                    </p>
                                    <button
                                      onClick={() =>
                                        this.props.match.params
                                          .affiliateKey === undefined
                                          ? this.onItemPlanClick(
                                              AllPlansForMember &&
                                                AllPlansForMember.records &&
                                                AllPlansForMember.records
                                                  .Small &&
                                                AllPlansForMember.records
                                                  .Small[2]
                                                ? AllPlansForMember.records
                                                    .Small[2].planId
                                                : "",

                                              AllPlansForMember &&
                                                AllPlansForMember.records &&
                                                AllPlansForMember.records
                                                  .Small &&
                                                AllPlansForMember.records
                                                  .Small[2]
                                                ? AllPlansForMember.records
                                                    .Small[2].planName
                                                : "",

                                              AllPlansForMember &&
                                                AllPlansForMember.records &&
                                                AllPlansForMember.records
                                                  .Small &&
                                                AllPlansForMember.records
                                                  .Small[2]
                                                ? AllPlansForMember.records
                                                    .Small[2]
                                                : ""
                                            )
                                          : this.onItemPlanClick(
                                              plansDataAffiliate &&
                                                plansDataAffiliate.result &&
                                                plansDataAffiliate.result
                                                  .affiliateSubscriptionDto &&
                                                plansDataAffiliate.result
                                                  .affiliateSubscriptionDto
                                                  .map &&
                                                plansDataAffiliate.result
                                                  .affiliateSubscriptionDto
                                                  .map.Small &&
                                                plansDataAffiliate.result
                                                  .affiliateSubscriptionDto
                                                  .map.Small[2]
                                                ? plansDataAffiliate.result
                                                    .affiliateSubscriptionDto
                                                    .map.Small[2].planId
                                                : "",
                                              plansDataAffiliate &&
                                                plansDataAffiliate.result &&
                                                plansDataAffiliate.result
                                                  .affiliateSubscriptionDto &&
                                                plansDataAffiliate.result
                                                  .affiliateSubscriptionDto
                                                  .map &&
                                                plansDataAffiliate.result
                                                  .affiliateSubscriptionDto
                                                  .map.Small &&
                                                plansDataAffiliate.result
                                                  .affiliateSubscriptionDto
                                                  .map.Small[2]
                                                ? plansDataAffiliate &&
                                                    plansDataAffiliate.result &&
                                                    plansDataAffiliate.result
                                                      .affiliateSubscriptionDto &&
                                                    plansDataAffiliate.result
                                                      .affiliateSubscriptionDto
                                                      .map &&
                                                    plansDataAffiliate.result
                                                      .affiliateSubscriptionDto
                                                      .map.Small &&
                                                    plansDataAffiliate.result
                                                      .affiliateSubscriptionDto
                                                      .map.Small[2].planName
                                                : "",
                                              plansDataAffiliate &&
                                                plansDataAffiliate.result &&
                                                plansDataAffiliate.result
                                                  .affiliateSubscriptionDto &&
                                                plansDataAffiliate.result
                                                  .affiliateSubscriptionDto
                                                  .map &&
                                                plansDataAffiliate.result
                                                  .affiliateSubscriptionDto
                                                  .map.Small &&
                                                plansDataAffiliate.result
                                                  .affiliateSubscriptionDto
                                                  .map.Small[0]
                                                ? plansDataAffiliate &&
                                                    plansDataAffiliate.result &&
                                                    plansDataAffiliate.result
                                                      .affiliateSubscriptionDto &&
                                                    plansDataAffiliate.result
                                                      .affiliateSubscriptionDto
                                                      .map &&
                                                    plansDataAffiliate.result
                                                      .affiliateSubscriptionDto
                                                      .map.Small &&
                                                    plansDataAffiliate.result
                                                      .affiliateSubscriptionDto
                                                      .map.Small[2]
                                                : ""
                                            )
                                      }
                                      className={
                                        this.props.match.params
                                          .affiliateKey === undefined
                                          ? AllPlansForMember &&
                                            AllPlansForMember.records &&
                                            AllPlansForMember.records.Small &&
                                            AllPlansForMember.records
                                              .Small[2] &&
                                            AllPlansForMember.records.Small[2]
                                              .planId === planId
                                            ? "waves-effect waves-light btn-small pink-btn"
                                            : "waves-effect waves-light btn-small white-btn"
                                          : plansDataAffiliate &&
                                            plansDataAffiliate.result &&
                                            plansDataAffiliate.result
                                              .affiliateSubscriptionDto &&
                                            plansDataAffiliate.result
                                              .affiliateSubscriptionDto.map &&
                                            plansDataAffiliate.result
                                              .affiliateSubscriptionDto.map
                                              .Small &&
                                            plansDataAffiliate.result
                                              .affiliateSubscriptionDto.map
                                              .Small[2] &&
                                            plansDataAffiliate.result
                                              .affiliateSubscriptionDto.map
                                              .Small[2].planId === planId
                                          ? "waves-effect waves-light btn-small pink-btn"
                                          : "waves-effect waves-light btn-small white-btn"
                                      }
                                    >
                                      Select Plan
                                    </button>

                                    <div
                                      className={
                                        showTabPlan3
                                          ? "list-collapse d-list"
                                          : "list-collapse"
                                      }
                                    >
                                      <ul>
                                        <li>
                                          You decide which claims are filed{" "}
                                        </li>
                                        <li>Unlimited claim filings</li>
                                        <li>
                                          We collect claim forms for all
                                          entities
                                        </li>
                                        <li>
                                          Personalized dashboard and
                                          settlement alerts
                                        </li>
                                        <li>
                                          {" "}
                                          Each additional EIN is +$1.00/month
                                          <br /> (capped at $250/month)
                                        </li>
                                      </ul>
                                    </div>
                                    <div
                                      className="link-collapse"
                                      onClick={() => {
                                        this.setState({
                                          showTabPlan3: !showTabPlan3
                                        });
                                      }}
                                    >
                                      {showTabPlan3
                                        ? "Show less"
                                        : "Show more"}
                                      <span className="down-arrow">
                                        {" "}
                                        <i
                                          className={
                                            showTabPlan3
                                              ? "material-icons angle-transposne"
                                              : " material-icons"
                                          }
                                        >
                                          expand_more
                                        </i>
                                      </span>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            ) : (
                              <div className=" plan-flex">
                                <div
                                  className={
                                    activePlanForBussness === "Premium"
                                      ? "col m4  step-1"
                                      : "col m4 step-1 disabled-plan-page"
                                  }
                                >
                                  <div className="plan-one">
                                    <h5 className="text-uppercase text-700 signup-title">
                                      {this.props.match.params
                                        .affiliateKey === undefined
                                        ? AllPlansForMember &&
                                          AllPlansForMember.records &&
                                          AllPlansForMember.records
                                            .Enterprise &&
                                          AllPlansForMember.records
                                            .Enterprise[0] &&
                                          AllPlansForMember.records
                                            .Enterprise[0].planName
                                        : plansDataAffiliate &&
                                          plansDataAffiliate.result &&
                                          plansDataAffiliate.result
                                            .affiliateSubscriptionDto &&
                                          plansDataAffiliate.result
                                            .affiliateSubscriptionDto.map &&
                                          plansDataAffiliate.result
                                            .affiliateSubscriptionDto.map
                                            .Enterprise &&
                                          plansDataAffiliate.result
                                            .affiliateSubscriptionDto.map
                                            .Enterprise[0]
                                        ? plansDataAffiliate &&
                                          plansDataAffiliate.result &&
                                          plansDataAffiliate.result
                                            .affiliateSubscriptionDto &&
                                          plansDataAffiliate.result
                                            .affiliateSubscriptionDto.map &&
                                          plansDataAffiliate.result
                                            .affiliateSubscriptionDto.map
                                            .Enterprise &&
                                          plansDataAffiliate.result
                                            .affiliateSubscriptionDto.map
                                            .Enterprise[0].planName
                                        : ""}
                                    </h5>
                                    <h5 className="signup-title2">
                                      No Upfront Cost
                                    </h5>
                                    <p className="plan-small-font">
                                      Collectively keeps{" "}
                                      <b>
                                        {" "}
                                        {this.props.match.params
                                          .affiliateKey === undefined
                                          ? AllPlansForMember &&
                                            AllPlansForMember.records &&
                                            AllPlansForMember.records
                                              .Enterprise &&
                                            AllPlansForMember.records
                                              .Enterprise[0] &&
                                            AllPlansForMember.records
                                              .Enterprise[0]
                                              .planPriceDto[0] &&
                                            AllPlansForMember.records.Enterprise[0].planPriceDto[0].fundCommission.toFixed(
                                              2
                                            )
                                          : plansDataAffiliate &&
                                            plansDataAffiliate.result &&
                                            plansDataAffiliate.result
                                              .affiliateSubscriptionDto &&
                                            plansDataAffiliate.result
                                              .affiliateSubscriptionDto.map &&
                                            plansDataAffiliate.result
                                              .affiliateSubscriptionDto.map
                                              .Enterprise &&
                                            plansDataAffiliate.result
                                              .affiliateSubscriptionDto.map
                                              .Enterprise[0]
                                              .planPriceDto[0] &&
                                            plansDataAffiliate.result.affiliateSubscriptionDto.map.Enterprise[0].planPriceDto[0].fundCommission.toFixed(
                                              2
                                            )}
                                        %{" "}
                                      </b>{" "}
                                      of collected funds
                                    </p>
                                    <p className="font-medium forcompany-web forcompany-mob">
                                      For companies that want to try out
                                      Collectively
                                    </p>
                                    <button
                                      onClick={() =>
                                        this.props.match.params
                                          .affiliateKey === undefined
                                          ? this.onItemPlanClick(
                                              AllPlansForMember &&
                                                AllPlansForMember.records &&
                                                AllPlansForMember.records
                                                  .Enterprise &&
                                                AllPlansForMember.records
                                                  .Enterprise[0]
                                                ? AllPlansForMember.records
                                                    .Enterprise[0].planId
                                                : "",

                                              AllPlansForMember &&
                                                AllPlansForMember.records &&
                                                AllPlansForMember.records
                                                  .Enterprise &&
                                                AllPlansForMember.records
                                                  .Enterprise[0]
                                                ? AllPlansForMember.records
                                                    .Enterprise[0].planName
                                                : "",

                                              AllPlansForMember &&
                                                AllPlansForMember.records &&
                                                AllPlansForMember.records
                                                  .Enterprise &&
                                                AllPlansForMember.records
                                                  .Enterprise[0]
                                                ? AllPlansForMember.records
                                                    .Enterprise[0]
                                                : ""
                                            )
                                          : this.onItemPlanClick(
                                              plansDataAffiliate &&
                                                plansDataAffiliate.result &&
                                                plansDataAffiliate.result
                                                  .affiliateSubscriptionDto &&
                                                plansDataAffiliate.result
                                                  .affiliateSubscriptionDto
                                                  .map &&
                                                plansDataAffiliate.result
                                                  .affiliateSubscriptionDto
                                                  .map.Enterprise &&
                                                plansDataAffiliate.result
                                                  .affiliateSubscriptionDto
                                                  .map.Enterprise[0]
                                                ? plansDataAffiliate.result
                                                    .affiliateSubscriptionDto
                                                    .map.Enterprise[0].planId
                                                : "",
                                              plansDataAffiliate &&
                                                plansDataAffiliate.result &&
                                                plansDataAffiliate.result
                                                  .affiliateSubscriptionDto &&
                                                plansDataAffiliate.result
                                                  .affiliateSubscriptionDto
                                                  .map &&
                                                plansDataAffiliate.result
                                                  .affiliateSubscriptionDto
                                                  .map.Enterprise &&
                                                plansDataAffiliate.result
                                                  .affiliateSubscriptionDto
                                                  .map.Enterprise[0]
                                                ? plansDataAffiliate &&
                                                    plansDataAffiliate.result &&
                                                    plansDataAffiliate.result
                                                      .affiliateSubscriptionDto &&
                                                    plansDataAffiliate.result
                                                      .affiliateSubscriptionDto
                                                      .map &&
                                                    plansDataAffiliate.result
                                                      .affiliateSubscriptionDto
                                                      .map.Enterprise &&
                                                    plansDataAffiliate.result
                                                      .affiliateSubscriptionDto
                                                      .map.Enterprise[0]
                                                      .planName
                                                : "",
                                              plansDataAffiliate &&
                                                plansDataAffiliate.result &&
                                                plansDataAffiliate.result
                                                  .affiliateSubscriptionDto &&
                                                plansDataAffiliate.result
                                                  .affiliateSubscriptionDto
                                                  .map &&
                                                plansDataAffiliate.result
                                                  .affiliateSubscriptionDto
                                                  .map.Small &&
                                                plansDataAffiliate.result
                                                  .affiliateSubscriptionDto
                                                  .map.Small[0]
                                                ? plansDataAffiliate &&
                                                    plansDataAffiliate.result &&
                                                    plansDataAffiliate.result
                                                      .affiliateSubscriptionDto &&
                                                    plansDataAffiliate.result
                                                      .affiliateSubscriptionDto
                                                      .map &&
                                                    plansDataAffiliate.result
                                                      .affiliateSubscriptionDto
                                                      .map.Small &&
                                                    plansDataAffiliate.result
                                                      .affiliateSubscriptionDto
                                                      .map.Enterprise[0]
                                                : ""
                                            )
                                      }
                                      className={
                                        this.props.match.params
                                          .affiliateKey === undefined
                                          ? AllPlansForMember &&
                                            AllPlansForMember.records &&
                                            AllPlansForMember.records
                                              .Enterprise &&
                                            AllPlansForMember.records
                                              .Enterprise[0] &&
                                            AllPlansForMember.records
                                              .Enterprise[0].planId === planId
                                            ? "waves-effect waves-light btn-small pink-btn"
                                            : "waves-effect waves-light btn-small white-btn"
                                          : plansDataAffiliate &&
                                            plansDataAffiliate.result &&
                                            plansDataAffiliate.result
                                              .affiliateSubscriptionDto &&
                                            plansDataAffiliate.result
                                              .affiliateSubscriptionDto.map &&
                                            plansDataAffiliate.result
                                              .affiliateSubscriptionDto.map
                                              .Enterprise &&
                                            plansDataAffiliate.result
                                              .affiliateSubscriptionDto.map
                                              .Enterprise[0] &&
                                            plansDataAffiliate.result
                                              .affiliateSubscriptionDto.map
                                              .Enterprise[0].planId === planId
                                          ? "waves-effect waves-light btn-small pink-btn"
                                          : "waves-effect waves-light btn-small white-btn"
                                      }
                                    >
                                      Select Plan
                                    </button>
                                    <div
                                      className={
                                        showTabPlan
                                          ? "list-collapse d-list"
                                          : "list-collapse"
                                      }
                                    >
                                      <ul>
                                        <li>
                                          Visa/Mastercard claim included
                                        </li>
                                        <li>
                                          File upto 10 claims per entity{" "}
                                          <sup>2</sup>
                                        </li>
                                        <li>
                                          We collect claim forms for all
                                          entities
                                        </li>
                                        <li>
                                          Personalized dashboard and
                                          settlement alerts
                                        </li>
                                        <li>Upgrade at anytime</li>
                                      </ul>
                                    </div>
                                    <div
                                      className="link-collapse"
                                      onClick={() => {
                                        this.setState({
                                          showTabPlan: !showTabPlan
                                        });
                                      }}
                                    >
                                      {showTabPlan
                                        ? "Show less"
                                        : "Show more"}

                                      <span className="down-arrow">
                                        {" "}
                                        <i
                                          className={
                                            showTabPlan
                                              ? "material-icons angle-transposne"
                                              : " material-icons"
                                          }
                                        >
                                          expand_more
                                        </i>
                                      </span>
                                    </div>
                                  </div>
                                </div>
                                <div
                                  className={
                                    activePlanForBussness === "Premium"
                                      ? "col m4 plan-2 step-2"
                                      : "col m4 step-2  disabled-plan-page"
                                  }
                                >
                                  <div className="plan-one premium-plan">
                                    <span className="best-value text-700 text-uppercase">
                                      Best value
                                    </span>
                                    <h5 className="text-uppercase text-700 signup-title text-pink">
                                      {this.props.match.params
                                        .affiliateKey === undefined
                                        ? AllPlansForMember &&
                                          AllPlansForMember.records &&
                                          AllPlansForMember.records
                                            .Enterprise &&
                                          AllPlansForMember.records
                                            .Enterprise[1] &&
                                          AllPlansForMember.records
                                            .Enterprise[1].planName
                                        : plansDataAffiliate &&
                                          plansDataAffiliate.result &&
                                          plansDataAffiliate.result
                                            .affiliateSubscriptionDto &&
                                          plansDataAffiliate.result
                                            .affiliateSubscriptionDto.map &&
                                          plansDataAffiliate.result
                                            .affiliateSubscriptionDto.map
                                            .Enterprise &&
                                          plansDataAffiliate.result
                                            .affiliateSubscriptionDto.map
                                            .Enterprise[1]
                                        ? plansDataAffiliate &&
                                          plansDataAffiliate.result &&
                                          plansDataAffiliate.result
                                            .affiliateSubscriptionDto &&
                                          plansDataAffiliate.result
                                            .affiliateSubscriptionDto.map &&
                                          plansDataAffiliate.result
                                            .affiliateSubscriptionDto.map
                                            .Enterprise &&
                                          plansDataAffiliate.result
                                            .affiliateSubscriptionDto.map
                                            .Enterprise[1].planName
                                        : ""}
                                    </h5>
                                    <h5 className="signup-title2">
                                      $
                                      {this.props.match.params
                                        .affiliateKey === undefined
                                        ? AllPlansForMember &&
                                          AllPlansForMember.records &&
                                          AllPlansForMember.records
                                            .Enterprise &&
                                          AllPlansForMember.records
                                            .Enterprise[1] &&
                                          AllPlansForMember.records
                                            .Enterprise[1].planPriceDto[0] &&
                                          AllPlansForMember.records.Enterprise[1].planPriceDto[0].subscriptionFees.toFixed(
                                            2
                                          )
                                        : plansDataAffiliate &&
                                          plansDataAffiliate.result &&
                                          plansDataAffiliate.result
                                            .affiliateSubscriptionDto &&
                                          plansDataAffiliate.result
                                            .affiliateSubscriptionDto.map &&
                                          plansDataAffiliate.result
                                            .affiliateSubscriptionDto.map
                                            .Enterprise &&
                                          plansDataAffiliate.result
                                            .affiliateSubscriptionDto.map
                                            .Enterprise[1].planPriceDto[0] &&
                                          plansDataAffiliate.result.affiliateSubscriptionDto.map.Enterprise[1].planPriceDto[0].subscriptionFees.toFixed(
                                            2
                                          )}
                                      /month <sup>1</sup>
                                    </h5>
                                    <p className="plan-small-font">
                                      Collectively keeps{" "}
                                      <b>
                                        {" "}
                                        {this.props.match.params
                                          .affiliateKey === undefined
                                          ? AllPlansForMember &&
                                            AllPlansForMember.records &&
                                            AllPlansForMember.records
                                              .Enterprise &&
                                            AllPlansForMember.records
                                              .Enterprise[1] &&
                                            AllPlansForMember.records
                                              .Enterprise[1]
                                              .planPriceDto[0] &&
                                            AllPlansForMember.records.Enterprise[1].planPriceDto[0].fundCommission.toFixed(
                                              2
                                            )
                                          : plansDataAffiliate &&
                                            plansDataAffiliate.result &&
                                            plansDataAffiliate.result
                                              .affiliateSubscriptionDto &&
                                            plansDataAffiliate.result
                                              .affiliateSubscriptionDto.map &&
                                            plansDataAffiliate.result
                                              .affiliateSubscriptionDto.map
                                              .Enterprise &&
                                            plansDataAffiliate.result
                                              .affiliateSubscriptionDto.map
                                              .Enterprise[0]
                                              .planPriceDto[0] &&
                                            plansDataAffiliate.result.affiliateSubscriptionDto.map.Enterprise[1].planPriceDto[0].fundCommission.toFixed(
                                              2
                                            )}{" "}
                                        %{" "}
                                      </b>{" "}
                                      of collected funds
                                    </p>
                                    <p className="font-medium forcompany-web forcompany-mob">
                                      For companies that want claims filed
                                      automatically
                                    </p>
                                    <button
                                      onClick={() =>
                                        this.props.match.params
                                          .affiliateKey === undefined
                                          ? this.onItemPlanClick(
                                              AllPlansForMember &&
                                                AllPlansForMember.records &&
                                                AllPlansForMember.records
                                                  .Enterprise &&
                                                AllPlansForMember.records
                                                  .Enterprise[1]
                                                ? AllPlansForMember.records
                                                    .Enterprise[1].planId
                                                : "",

                                              AllPlansForMember &&
                                                AllPlansForMember.records &&
                                                AllPlansForMember.records
                                                  .Enterprise &&
                                                AllPlansForMember.records
                                                  .Enterprise[1]
                                                ? AllPlansForMember.records
                                                    .Enterprise[1].planName
                                                : "",

                                              AllPlansForMember &&
                                                AllPlansForMember.records &&
                                                AllPlansForMember.records
                                                  .Enterprise &&
                                                AllPlansForMember.records
                                                  .Enterprise[1]
                                                ? AllPlansForMember.records
                                                    .Enterprise[1]
                                                : ""
                                            )
                                          : this.onItemPlanClick(
                                              plansDataAffiliate &&
                                                plansDataAffiliate.result &&
                                                plansDataAffiliate.result
                                                  .affiliateSubscriptionDto &&
                                                plansDataAffiliate.result
                                                  .affiliateSubscriptionDto
                                                  .map &&
                                                plansDataAffiliate.result
                                                  .affiliateSubscriptionDto
                                                  .map.Enterprise &&
                                                plansDataAffiliate.result
                                                  .affiliateSubscriptionDto
                                                  .map.Enterprise[1]
                                                ? plansDataAffiliate.result
                                                    .affiliateSubscriptionDto
                                                    .map.Enterprise[1].planId
                                                : "",
                                              plansDataAffiliate &&
                                                plansDataAffiliate.result &&
                                                plansDataAffiliate.result
                                                  .affiliateSubscriptionDto &&
                                                plansDataAffiliate.result
                                                  .affiliateSubscriptionDto
                                                  .map &&
                                                plansDataAffiliate.result
                                                  .affiliateSubscriptionDto
                                                  .map.Enterprise &&
                                                plansDataAffiliate.result
                                                  .affiliateSubscriptionDto
                                                  .map.Enterprise[1]
                                                ? plansDataAffiliate &&
                                                    plansDataAffiliate.result &&
                                                    plansDataAffiliate.result
                                                      .affiliateSubscriptionDto &&
                                                    plansDataAffiliate.result
                                                      .affiliateSubscriptionDto
                                                      .map &&
                                                    plansDataAffiliate.result
                                                      .affiliateSubscriptionDto
                                                      .map.Enterprise &&
                                                    plansDataAffiliate.result
                                                      .affiliateSubscriptionDto
                                                      .map.Enterprise[1]
                                                      .planName
                                                : "",
                                              plansDataAffiliate &&
                                                plansDataAffiliate.result &&
                                                plansDataAffiliate.result
                                                  .affiliateSubscriptionDto &&
                                                plansDataAffiliate.result
                                                  .affiliateSubscriptionDto
                                                  .map &&
                                                plansDataAffiliate.result
                                                  .affiliateSubscriptionDto
                                                  .map.Small &&
                                                plansDataAffiliate.result
                                                  .affiliateSubscriptionDto
                                                  .map.Small[0]
                                                ? plansDataAffiliate &&
                                                    plansDataAffiliate.result &&
                                                    plansDataAffiliate.result
                                                      .affiliateSubscriptionDto &&
                                                    plansDataAffiliate.result
                                                      .affiliateSubscriptionDto
                                                      .map &&
                                                    plansDataAffiliate.result
                                                      .affiliateSubscriptionDto
                                                      .map.Small &&
                                                    plansDataAffiliate.result
                                                      .affiliateSubscriptionDto
                                                      .map.Enterprise[1]
                                                : ""
                                            )
                                      }
                                      className={
                                        this.props.match.params
                                          .affiliateKey === undefined
                                          ? AllPlansForMember &&
                                            AllPlansForMember.records &&
                                            AllPlansForMember.records
                                              .Enterprise &&
                                            AllPlansForMember.records
                                              .Enterprise[1] &&
                                            AllPlansForMember.records
                                              .Enterprise[1].planId === planId
                                            ? "waves-effect waves-light btn-small pink-btn"
                                            : "waves-effect waves-light btn-small white-btn"
                                          : plansDataAffiliate &&
                                            plansDataAffiliate.result &&
                                            plansDataAffiliate.result
                                              .affiliateSubscriptionDto &&
                                            plansDataAffiliate.result
                                              .affiliateSubscriptionDto.map &&
                                            plansDataAffiliate.result
                                              .affiliateSubscriptionDto.map
                                              .Enterprise &&
                                            plansDataAffiliate.result
                                              .affiliateSubscriptionDto.map
                                              .Enterprise[1] &&
                                            plansDataAffiliate.result
                                              .affiliateSubscriptionDto.map
                                              .Enterprise[1].planId === planId
                                          ? "waves-effect waves-light btn-small pink-btn"
                                          : "waves-effect waves-light btn-small white-btn"
                                      }
                                    >
                                      Select Plan
                                    </button>
                                    <div
                                      className={
                                        showTabPlan1
                                          ? "list-collapse d-list"
                                          : "list-collapse"
                                      }
                                    >
                                      <ul>
                                        <li>
                                          Claims filed automatically{" "}
                                          <sup>2</sup>
                                        </li>
                                        <li>Unlimited claim filings</li>
                                        <li>
                                          We collect claim forms for all
                                          entities
                                        </li>
                                        <li>
                                          Personalized dashboard and
                                          settlement alerts
                                        </li>
                                      </ul>
                                    </div>
                                    <div
                                      className="link-collapse"
                                      onClick={() => {
                                        this.setState({
                                          showTabPlan1: !showTabPlan1
                                        });
                                      }}
                                    >
                                      {showTabPlan1
                                        ? "Show less"
                                        : "Show more"}

                                      <span className="down-arrow">
                                        {" "}
                                        <i
                                          className={
                                            showTabPlan1
                                              ? "material-icons angle-transposne"
                                              : " material-icons"
                                          }
                                        >
                                          expand_more
                                        </i>
                                      </span>
                                    </div>
                                  </div>
                                </div>
                                <div
                                  className={
                                    activePlanForBussness === "flex"
                                      ? "col m4 plan-3 step-3"
                                      : "step-3 disabled-plan-page"
                                  }
                                >
                                  <div className="plan-one premium-plan">
                                    <h5 className="text-uppercase text-700 signup-title">
                                      {this.props.match.params
                                        .affiliateKey === undefined
                                        ? AllPlansForMember &&
                                          AllPlansForMember.records &&
                                          AllPlansForMember.records
                                            .Enterprise &&
                                          AllPlansForMember.records
                                            .Enterprise[2] &&
                                          AllPlansForMember.records
                                            .Enterprise[2].planName
                                        : plansDataAffiliate &&
                                          plansDataAffiliate.result &&
                                          plansDataAffiliate.result
                                            .affiliateSubscriptionDto &&
                                          plansDataAffiliate.result
                                            .affiliateSubscriptionDto.map &&
                                          plansDataAffiliate.result
                                            .affiliateSubscriptionDto.map
                                            .Enterprise &&
                                          plansDataAffiliate.result
                                            .affiliateSubscriptionDto.map
                                            .Enterprise[2]
                                        ? plansDataAffiliate &&
                                          plansDataAffiliate.result &&
                                          plansDataAffiliate.result
                                            .affiliateSubscriptionDto &&
                                          plansDataAffiliate.result
                                            .affiliateSubscriptionDto.map &&
                                          plansDataAffiliate.result
                                            .affiliateSubscriptionDto.map
                                            .Enterprise &&
                                          plansDataAffiliate.result
                                            .affiliateSubscriptionDto.map
                                            .Enterprise[2].planName
                                        : ""}{" "}
                                    </h5>
                                    <h5 className="signup-title2">
                                      $
                                      {this.props.match.params
                                        .affiliateKey === undefined
                                        ? AllPlansForMember &&
                                          AllPlansForMember.records &&
                                          AllPlansForMember.records
                                            .Enterprise &&
                                          AllPlansForMember.records
                                            .Enterprise[2] &&
                                          AllPlansForMember.records
                                            .Enterprise[2].planPriceDto[0] &&
                                          AllPlansForMember.records.Enterprise[2].planPriceDto[0].subscriptionFees.toFixed(
                                            2
                                          )
                                        : plansDataAffiliate &&
                                          plansDataAffiliate.result &&
                                          plansDataAffiliate.result
                                            .affiliateSubscriptionDto &&
                                          plansDataAffiliate.result
                                            .affiliateSubscriptionDto.map &&
                                          plansDataAffiliate.result
                                            .affiliateSubscriptionDto.map
                                            .Enterprise &&
                                          plansDataAffiliate.result
                                            .affiliateSubscriptionDto.map
                                            .Enterprise[0].planPriceDto[0] &&
                                          plansDataAffiliate.result.affiliateSubscriptionDto.map.Enterprise[2].planPriceDto[0].subscriptionFees.toFixed(
                                            2
                                          )}
                                      /month <sup>1</sup>
                                    </h5>
                                    <p className="plan-small-font">
                                      Collectively keeps{" "}
                                      <b>
                                        {" "}
                                        {this.props.match.params
                                          .affiliateKey === undefined
                                          ? AllPlansForMember &&
                                            AllPlansForMember.records &&
                                            AllPlansForMember.records
                                              .Enterprise &&
                                            AllPlansForMember.records
                                              .Enterprise[2] &&
                                            AllPlansForMember.records
                                              .Enterprise[2]
                                              .planPriceDto[0] &&
                                            AllPlansForMember.records.Enterprise[2].planPriceDto[0].fundCommission.toFixed(
                                              2
                                            )
                                          : plansDataAffiliate &&
                                            plansDataAffiliate.result &&
                                            plansDataAffiliate.result
                                              .affiliateSubscriptionDto &&
                                            plansDataAffiliate.result
                                              .affiliateSubscriptionDto.map &&
                                            plansDataAffiliate.result
                                              .affiliateSubscriptionDto.map
                                              .Enterprise &&
                                            plansDataAffiliate.result
                                              .affiliateSubscriptionDto.map
                                              .Enterprise[0]
                                              .planPriceDto[0] &&
                                            plansDataAffiliate.result.affiliateSubscriptionDto.map.Enterprise[2].planPriceDto[0].fundCommission.toFixed(
                                              2
                                            )}
                                        %{" "}
                                      </b>{" "}
                                      of collected funds
                                    </p>
                                    <p className="font-medium forcompany-web forcompany-mob">
                                      For companies that want to be more hands
                                      on
                                    </p>
                                    <button
                                      onClick={() =>
                                        this.props.match.params
                                          .affiliateKey === undefined
                                          ? this.onItemPlanClick(
                                              AllPlansForMember &&
                                                AllPlansForMember.records &&
                                                AllPlansForMember.records
                                                  .Enterprise &&
                                                AllPlansForMember.records
                                                  .Enterprise[2]
                                                ? AllPlansForMember.records
                                                    .Enterprise[2].planId
                                                : "",

                                              AllPlansForMember &&
                                                AllPlansForMember.records &&
                                                AllPlansForMember.records
                                                  .Enterprise &&
                                                AllPlansForMember.records
                                                  .Enterprise[2]
                                                ? AllPlansForMember.records
                                                    .Enterprise[2].planName
                                                : "",

                                              AllPlansForMember &&
                                                AllPlansForMember.records &&
                                                AllPlansForMember.records
                                                  .Enterprise &&
                                                AllPlansForMember.records
                                                  .Enterprise[2]
                                                ? AllPlansForMember.records
                                                    .Enterprise[2]
                                                : ""
                                            )
                                          : this.onItemPlanClick(
                                              plansDataAffiliate &&
                                                plansDataAffiliate.result &&
                                                plansDataAffiliate.result
                                                  .affiliateSubscriptionDto &&
                                                plansDataAffiliate.result
                                                  .affiliateSubscriptionDto
                                                  .map &&
                                                plansDataAffiliate.result
                                                  .affiliateSubscriptionDto
                                                  .map.Enterprise &&
                                                plansDataAffiliate.result
                                                  .affiliateSubscriptionDto
                                                  .map.Enterprise[2]
                                                ? plansDataAffiliate.result
                                                    .affiliateSubscriptionDto
                                                    .map.Enterprise[2].planId
                                                : "",
                                              plansDataAffiliate &&
                                                plansDataAffiliate.result &&
                                                plansDataAffiliate.result
                                                  .affiliateSubscriptionDto &&
                                                plansDataAffiliate.result
                                                  .affiliateSubscriptionDto
                                                  .map &&
                                                plansDataAffiliate.result
                                                  .affiliateSubscriptionDto
                                                  .map.Enterprise &&
                                                plansDataAffiliate.result
                                                  .affiliateSubscriptionDto
                                                  .map.Enterprise[2]
                                                ? plansDataAffiliate &&
                                                    plansDataAffiliate.result &&
                                                    plansDataAffiliate.result
                                                      .affiliateSubscriptionDto &&
                                                    plansDataAffiliate.result
                                                      .affiliateSubscriptionDto
                                                      .map &&
                                                    plansDataAffiliate.result
                                                      .affiliateSubscriptionDto
                                                      .map.Enterprise &&
                                                    plansDataAffiliate.result
                                                      .affiliateSubscriptionDto
                                                      .map.Enterprise[2]
                                                      .planName
                                                : "",
                                              plansDataAffiliate &&
                                                plansDataAffiliate.result &&
                                                plansDataAffiliate.result
                                                  .affiliateSubscriptionDto &&
                                                plansDataAffiliate.result
                                                  .affiliateSubscriptionDto
                                                  .map &&
                                                plansDataAffiliate.result
                                                  .affiliateSubscriptionDto
                                                  .map.Enterprise &&
                                                plansDataAffiliate.result
                                                  .affiliateSubscriptionDto
                                                  .map.Enterprise[2]
                                                ? plansDataAffiliate &&
                                                    plansDataAffiliate.result &&
                                                    plansDataAffiliate.result
                                                      .affiliateSubscriptionDto &&
                                                    plansDataAffiliate.result
                                                      .affiliateSubscriptionDto
                                                      .map &&
                                                    plansDataAffiliate.result
                                                      .affiliateSubscriptionDto
                                                      .map.Small &&
                                                    plansDataAffiliate.result
                                                      .affiliateSubscriptionDto
                                                      .map.Enterprise[2]
                                                : ""
                                            )
                                      }
                                      className={
                                        this.props.match.params
                                          .affiliateKey === undefined
                                          ? AllPlansForMember &&
                                            AllPlansForMember.records &&
                                            AllPlansForMember.records
                                              .Enterprise &&
                                            AllPlansForMember.records
                                              .Enterprise[2] &&
                                            AllPlansForMember.records
                                              .Enterprise[2].planId === planId
                                            ? "waves-effect waves-light btn-small pink-btn"
                                            : "waves-effect waves-light btn-small white-btn"
                                          : plansDataAffiliate &&
                                            plansDataAffiliate.result &&
                                            plansDataAffiliate.result
                                              .affiliateSubscriptionDto &&
                                            plansDataAffiliate.result
                                              .affiliateSubscriptionDto.map &&
                                            plansDataAffiliate.result
                                              .affiliateSubscriptionDto.map
                                              .Enterprise &&
                                            plansDataAffiliate.result
                                              .affiliateSubscriptionDto.map
                                              .Enterprise[2] &&
                                            plansDataAffiliate.result
                                              .affiliateSubscriptionDto.map
                                              .Enterprise[2].planId === planId
                                          ? "waves-effect waves-light btn-small pink-btn"
                                          : "waves-effect waves-light btn-small white-btn"
                                      }
                                    >
                                      Select Plan
                                    </button>
                                    <div
                                      className={
                                        showTabPlan2
                                          ? "list-collapse d-list"
                                          : "list-collapse"
                                      }
                                    >
                                      <ul>
                                        <li>
                                          You decide which claims are filed{" "}
                                        </li>
                                        <li>Unlimited claim filings</li>
                                        <li>
                                          We collect claim forms for all
                                          entities
                                        </li>
                                        <li>
                                          Personalized dashboard and
                                          settlement alerts
                                        </li>
                                      </ul>
                                    </div>
                                    <div
                                      className="link-collapse"
                                      onClick={() => {
                                        this.setState({
                                          showTabPlan2: !showTabPlan2
                                        });
                                      }}
                                    >
                                      {showTabPlan2
                                        ? "Show less"
                                        : "Show more"}

                                      <span className="down-arrow">
                                        {" "}
                                        <i
                                          className={
                                            showTabPlan2
                                              ? "material-icons angle-transposne"
                                              : " material-icons"
                                          }
                                        >
                                          expand_more
                                        </i>
                                      </span>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            )}
                            <button
                                className='waves-effect waves-light white-btn payment-page-back-button'
                                type='submit'
                                onClick={this.redirectToDashboard}
                                name='action'
                              >
                                Back
                            </button>
                            <div className="plan-bottom">
                              <ol>
                                <li>
                                  Yearly payment options available at
                                  checkout.
                                </li>
                                <li>
                                  Claims are automatically filed when claims
                                  data is readily available. We try to only
                                  contact you if additional information is
                                  necessary to start the claims process.
                                </li>
                              </ol>
                              <div className="compare-plan-toggle">
                                <div className="row">
                                  <div className="col s12">
                                    <p>
                                      <a
                                        onClick={() => {
                                          this.setState({
                                            showplanDetail: !showplanDetail
                                          });
                                        }}
                                      >
                                        <span>Compare the value</span> of each
                                        plan{" "}
                                        <span className="down-arrow">
                                          {" "}
                                          <i
                                            className={
                                              showplanDetail
                                                ? "material-icons angle-transposne"
                                                : " material-icons"
                                            }
                                          >
                                            expand_more
                                          </i>
                                        </span>
                                      </a>
                                    </p>
                                  </div>
                                </div>
                                <div
                                  className={
                                    showplanDetail
                                      ? "compare-plan-toggle-data"
                                      : "compare-plan-toggle-data-hide"
                                  }
                                >
                                  <div className="row">
                                    <div className="col s12">
                                      <h6>
                                        Since settlements often take time to
                                        payout, below is an example of a
                                        company using Collectively over a 5
                                        year span. As shown in the chart, the
                                        Premium plan is the most efficient and
                                        offers the best value.
                                      </h6>
                                    </div>
                                    <div className="col s12 m4 plan-bottom-left">
                                      <h6 className="mt-mob-none text-uppercase">
                                        Example Recovery
                                      </h6>
                                      <h4>
                                        $50,000 <sup>3</sup>
                                      </h4>
                                      <h6 className="text-uppercase">
                                        Total Collected
                                      </h6>
                                      <ul>
                                        <li>10 Settlements</li>
                                        <li>
                                          $5,000 collected per Settlement
                                        </li>
                                      </ul>
                                    </div>
                                    <div className="col s12 m8 plan-bottom-right">
                                      <table className="table">
                                        <thead>
                                          <tr>
                                            <th />
                                            <th>Basic</th>
                                            <th>Premium</th>
                                            <th>Flex</th>
                                          </tr>
                                        </thead>

                                        <tbody>
                                          <tr>
                                            <td>
                                              Monthly Fee (1 Ein over 5 years){" "}
                                              <sup>4</sup>
                                            </td>
                                            <td>$0.00</td>
                                            <td>$499.88</td>
                                            <td>$587.00</td>
                                          </tr>
                                          <tr>
                                            <td>Collectively keeps</td>
                                            <td>$ 9,975.00</td>
                                            <td>$ 4,975.00</td>
                                            <td>$ 6,975.00</td>
                                          </tr>
                                          <tr>
                                            <td>You Collect</td>
                                            <td>$40,025.00</td>
                                            <td>
                                              <b>$44,525.20</b>
                                            </td>
                                            <td>$42,438.00</td>
                                          </tr>
                                        </tbody>
                                      </table>
                                      <ol>
                                        <li className="hidden" />
                                        <li className="hidden" />
                                        <li>
                                          The total recovery and average per
                                          settlement is for example purposes
                                          only. We are not estimating the
                                          actual value users might collect
                                          from settlements.
                                        </li>
                                        <li>
                                          The above example only includes 1
                                          EIN (Employer Identification
                                          Number/Tax ID Number)
                                        </li>
                                      </ol>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </TabPanel>

                      <TabPanel>
                        <div

                        >
                          <TermAndCondition
                            termsAndConditionData={this.handleSaveData}
                            termsAndConditionDataNextPage={
                              this.handleSaveDataNext
                            }
                            termsAndConditionBack={this.backClick}
                            readDisclaimer={readDisclaimer}
                            readUserAgreement={readUserAgreement}
                            readPrivacyPolicy={readPrivacyPolicy}
                            readLetterOfAgency={readLetterOfAgency}
                            pageType="business"
                            backButton
                            signupData={this.state}
                            defaultValue={signatureDefaultValue}
                            fontFamily={signatureFontFamily}
                            // finalSubmitData={this.finalSubmit}
                            fileImage={this.fileImage}
                            moveTop={this.topScreen}
                            fileData={file}
                            hide
                            makepayment={
                              planName === "Basic" || connectFusebill === 0
                            }
                            selectedPlanAmount={selectedPlanAmount}
                          />
                        </div>

                      </TabPanel>

                      <TabPanel
                        className={
                          planName === "Basic" || connectFusebill === 0
                            ? "hide-tab-info"
                            : ""
                        }
                      >
                        <div className="signup-tab-align">
                          <div
                            id="checkout-tab"
                            className="col s12 main-content signup-new-tabs-content ibmfont"
                          >
                            <h4 className="center-align signup-title">
                              Checkout
                            </h4>
                            <a
                              className="change-plan change-plan-mob"
                              onClick={() => {
                                this.setState({
                                  tabValue: 0
                                });
                              }}
                            >
                              Change Plan
                            </a>
                            <p className="center-align signup-title2 checkout-tagline-mob">
                              Choose a payment term for your {planName} plan:
                            </p>

                            <div className="row">
                              <div className="col s12 l10 offset-l1">
                                <ul className="tabs">
                                  {this.props.match.params.affiliateKey ===
                                  undefined
                                    ? AllPlansForMember &&
                                      AllPlansForMember.records &&
                                      AllPlansForMember.records[
                                        enterpriseType === "S"
                                          ? "Small"
                                          : "Enterprise"
                                      ].findIndex(
                                        item1 => item1.planName === planName
                                      ) !== -1
                                      ? AllPlansForMember.records[
                                          enterpriseType === "S"
                                            ? "Small"
                                            : "Enterprise"
                                        ][
                                          AllPlansForMember.records[
                                            enterpriseType === "S"
                                              ? "Small"
                                              : "Enterprise"
                                          ].findIndex(
                                            item1 =>
                                              item1.planName === planName
                                          )
                                        ] &&
                                        AllPlansForMember.records[
                                          enterpriseType === "S"
                                            ? "Small"
                                            : "Enterprise"
                                        ][
                                          AllPlansForMember.records[
                                            enterpriseType === "S"
                                              ? "Small"
                                              : "Enterprise"
                                          ].findIndex(
                                            item1 =>
                                              item1.planName === planName
                                          )
                                        ].planPriceDto.map((iteam, index) => (
                                          <li key={index} className="tab">
                                            <a
                                              className={
                                                iteam.planPriceId ===
                                                planPriceId
                                                  ? "active"
                                                  : ""
                                              }
                                              onClick={() =>
                                                this.selectPricePlainDetail(
                                                  iteam.planPriceId,
                                                  iteam.subscriptionFees,
                                                  iteam.durationType,
                                                  iteam.duration,
                                                  iteam.fusebillPlanId,
                                                  iteam.fusebillPlanFrequencyId,
                                                  iteam.connectFusebill,
                                                  iteam.durationType ===
                                                    "Month"
                                                    ? 1
                                                    : 12 * iteam.duration,
                                                  index !== 0
                                                    ? 1 -
                                                        (index * 5 + 5) / 100
                                                    : 0
                                                )
                                              }
                                            >
                                              {iteam.duration !== 1
                                                ? iteam.duration
                                                : ""}{" "}
                                              {iteam.durationType === "Month"
                                                ? "Monthly"
                                                : iteam.duration > 1
                                                ? "Years"
                                                : "Yearly"}
                                              <span
                                                className={
                                                  iteam.durationType ===
                                                  "Month"
                                                    ? "monthly-price"
                                                    : ""
                                                }
                                              >
                                                {iteam.durationType ===
                                                "Month"
                                                  ? `$${iteam.subscriptionFees.toFixed(
                                                      2
                                                    )}`
                                                  : `SAVE ${5 + index * 5} %`}
                                              </span>
                                            </a>
                                          </li>
                                        ))
                                      : ""
                                    : plansDataAffiliate &&
                                      plansDataAffiliate.result &&
                                      plansDataAffiliate.result
                                        .affiliateSubscriptionDto &&
                                      plansDataAffiliate.result
                                        .affiliateSubscriptionDto.map &&
                                      plansDataAffiliate.result.affiliateSubscriptionDto.map[
                                        enterpriseType === "S"
                                          ? "Small"
                                          : "Enterprise"
                                      ].findIndex(
                                        item1 => item1.planName === planName
                                      ) !== -1
                                    ? plansDataAffiliate.result
                                        .affiliateSubscriptionDto.map[
                                        enterpriseType === "S"
                                          ? "Small"
                                          : "Enterprise"
                                      ][
                                        plansDataAffiliate.result.affiliateSubscriptionDto.map[
                                          enterpriseType === "S"
                                            ? "Small"
                                            : "Enterprise"
                                        ].findIndex(
                                          item1 => item1.planName === planName
                                        )
                                      ] &&
                                      plansDataAffiliate.result.affiliateSubscriptionDto.map[
                                        enterpriseType === "S"
                                          ? "Small"
                                          : "Enterprise"
                                      ][
                                        plansDataAffiliate.result.affiliateSubscriptionDto.map[
                                          enterpriseType === "S"
                                            ? "Small"
                                            : "Enterprise"
                                        ].findIndex(
                                          item1 => item1.planName === planName
                                        )
                                      ].planPriceDto.map((iteam, index) => (
                                        <li key={index} className="tab">
                                          <a
                                            className={
                                              iteam.planPriceId ===
                                              planPriceId
                                                ? "active"
                                                : ""
                                            }
                                            onClick={() =>
                                              this.selectPricePlainDetail(
                                                iteam.planPriceId,
                                                iteam.subscriptionFees,
                                                iteam.durationType,
                                                iteam.duration,
                                                iteam.fusebillPlanId,
                                                iteam.fusebillPlanFrequencyId,
                                                iteam.connectFusebill,
                                                iteam.durationType === "Month"
                                                  ? 1
                                                  : 12 * iteam.duration,
                                                index !== 0
                                                  ? 1 - (index * 5 + 5) / 100
                                                  : 0
                                              )
                                            }
                                          >
                                            {iteam.duration !== 1
                                              ? iteam.duration
                                              : ""}{" "}
                                            {iteam.durationType === "Month"
                                              ? "Monthly"
                                              : iteam.duration > 1
                                              ? "Years"
                                              : "Yearly"}
                                            <span
                                              className={
                                                iteam.durationType === "Month"
                                                  ? "monthly-price"
                                                  : ""
                                              }
                                            >
                                              {iteam.durationType === "Month"
                                                ? `$${iteam.subscriptionFees.toFixed(
                                                    2
                                                  )}`
                                                : `SAVE ${5 + index * 5} %`}
                                            </span>
                                          </a>
                                        </li>
                                      ))
                                    : ""}
                                </ul>

                                <div className="clear tab-inner p-x-none-mob">
                                  <div
                                    id="plan1"
                                    className="col s12 p-x-none-mob sign-tab-content center-align pad-x-none"
                                  >
                                    <div className="plan-detail">
                                      <div className="row">
                                        <div className="col s12 p-x-none-mob">
                                          {enterpriseType === "S" ? (
                                            <p className="per-mnth-plan">
                                              Each additional EIN is
                                              +$1.00/month (capped at
                                              $250/month)
                                            </p>
                                          ) : (
                                            ""
                                          )}
                                          {durationData !== "1 Month" ? (
                                            <p className="per-year-plan right-align">
                                              Your Total for{" "}
                                              {enterpriseType === "S"
                                                ? totalTaxId > 0
                                                  ? `${parseInt(
                                                      totalTaxId,
                                                      10
                                                    ) + 1}  EINs over `
                                                  : `1 EIN over `
                                                : ""}{" "}
                                              {durationData === "1 year"
                                                ? `${durationData} `
                                                : `${durationData}s `}
                                              is{" "}
                                              <span>
                                                $
                                                {(
                                                  parseFloat(
                                                    selectedPlanAmount !== ""
                                                      ? selectedPlanAmount.toFixed(
                                                          2
                                                        )
                                                      : 0.0
                                                  ) +
                                                  parseFloat(
                                                    enterpriseType === "S"
                                                      ? totalTaxId < 250
                                                        ? totalTaxId *
                                                          durationCheckout *
                                                          discountCheckout
                                                        : 250 *
                                                          durationCheckout *
                                                          discountCheckout
                                                      : 0.0
                                                  )
                                                ).toFixed(2)}{" "}
                                                /{" "}
                                                {durationData === "1 year"
                                                  ? `year`
                                                  : `${durationData}s `}
                                              </span>
                                            </p>
                                          ) : (
                                            <table className="checkout-table">
                                              <tbody>
                                                <tr>
                                                  <td className="right-align">
                                                    Your Current Plan
                                                  </td>
                                                  <td className="right-align">
                                                    $
                                                    {selectedPlanAmount !== ""
                                                      ? selectedPlanAmount.toFixed(
                                                          2
                                                        )
                                                      : 0.0}
                                                  </td>
                                                </tr>
                                                {enterpriseType === "S" && (
                                                  <tr>
                                                    <td className="right-align">
                                                      + {totalTaxId} EINs
                                                    </td>
                                                    <td className="right-align">
                                                      $
                                                      {parseFloat(
                                                        enterpriseType === "S"
                                                          ? totalTaxId < 250
                                                            ? totalTaxId
                                                            : 250
                                                          : 0.0
                                                      ).toFixed(2)}
                                                    </td>
                                                  </tr>
                                                )}
                                                <tr>
                                                  <td className="right-align">
                                                    <b>Monthly Total</b>
                                                  </td>
                                                  <td className="right-align total">
                                                    <b>
                                                      $
                                                      {(
                                                        parseFloat(
                                                          selectedPlanAmount !==
                                                            ""
                                                            ? selectedPlanAmount.toFixed(
                                                                2
                                                              )
                                                            : 0.0
                                                        ) +
                                                        parseFloat(
                                                          enterpriseType ===
                                                            "S"
                                                            ? totalTaxId < 250
                                                              ? totalTaxId
                                                              : 250
                                                            : 0.0
                                                        )
                                                      ).toFixed(2)}{" "}
                                                      / month
                                                    </b>
                                                  </td>
                                                </tr>
                                                <tr>
                                                  {/* <td
                                                    className="right-align contingent-fee"
                                                    colSpan="2"
                                                  >
                                                    Plus any contingent fees
                                                </td> */}
                                                </tr>
                                              </tbody>
                                            </table>
                                          )}
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                  <div
                                    id="plan2"
                                    className="col s12 sign-tab-content center-align pad-x-none"
                                  />
                                  <div
                                    id="plan3"
                                    className="col s12 sign-tab-content center-align pad-x-none"
                                  >
                                    {" "}
                                  </div>
                                  <div
                                    id="plan4"
                                    className="col s12 sign-tab-content center-align pad-x-none"
                                  >
                                    {" "}
                                  </div>
                                </div>

                                {planName !== "Basic" &&
                                (planName,
                                this.props.match.params.affiliateKey ===
                                undefined
                                  ? 1
                                  : plansDataAffiliate &&
                                    plansDataAffiliate.result &&
                                    plansDataAffiliate.result
                                      .affiliateSubscriptionDto &&
                                    plansDataAffiliate.result
                                      .affiliateSubscriptionDto.map &&
                                    plansDataAffiliate.result.affiliateSubscriptionDto.map[
                                      enterpriseType === "S"
                                        ? "Small"
                                        : "Enterprise"
                                    ].findIndex(
                                      item1 => item1.planName === planName
                                    ) !== -1
                                  ? plansDataAffiliate.result
                                      .affiliateSubscriptionDto.map[
                                      enterpriseType === "S"
                                        ? "Small"
                                        : "Enterprise"
                                    ][
                                      plansDataAffiliate.result.affiliateSubscriptionDto.map[
                                        enterpriseType === "S"
                                          ? "Small"
                                          : "Enterprise"
                                      ].findIndex(
                                        item1 => item1.planName === planName
                                      )
                                    ] &&
                                    plansDataAffiliate.result
                                      .affiliateSubscriptionDto.map[
                                      enterpriseType === "S"
                                        ? "Small"
                                        : "Enterprise"
                                    ][
                                      plansDataAffiliate.result.affiliateSubscriptionDto.map[
                                        enterpriseType === "S"
                                          ? "Small"
                                          : "Enterprise"
                                      ].findIndex(
                                        item1 => item1.planName === planName
                                      )
                                    ].planPriceDto[0].connectFusebill === 1
                                    ? 1
                                    : 0
                                  : 0) !== 0 ? (
                                  <div id="info-tab" className="row">
                                    <form className="tab-inner p-x-none-mob">
                                      <div className="row">
                                        <div className="col s12 pb-20 pad-x-none">
                                          <h6 className="signup-title checkout-title checkout-title-uppercase">
                                            Enter your card information
                                          </h6>

                                          <p>
                                            <label>
                                              <input
                                                className="with-gap"
                                                name="group5"
                                                type="checkbox"
                                                onChange={this.cardOnChange}
                                                checked={sameAddress}
                                              />
                                              <span className="text-black">
                                                Same as address from Signup
                                              </span>
                                            </label>
                                          </p>
                                        </div>
                                        <CardInputMaskinking
                                          divClassName="input-field col s12 pb-20 pad-x-none"
                                          field="cardNumber"
                                          label="Card Number *"
                                          placeholder="Card Number"
                                          value={cardNumber}
                                          error={cardErrors.cardNumber}
                                          onChange={this.onChangeCarad}
                                          mask="9999 9999 9999 9999"
                                        />

                                        <CardInputField
                                          divClassName="input-field col s12 m6 pb-20 pad-x-none"
                                          field="cardFirstName"
                                          label="First Name *"
                                          // placeholder="Name on Card"
                                          value={cardFirstName}
                                          error={
                                            cardErrors.cardFirstName
                                          }
                                          onChange={this.onChangeCarad}
                                        />
                                        <CardInputField
                                          divClassName="input-field col s12 m6 claimaint-input-half-rt pb-20 pad-x-none"
                                          field="cardLastName"
                                          label="Last Name  *"
                                          // placeholder="Name on Card"
                                          value={cardLastName}
                                          error={
                                            cardErrors.cardLastName
                                          }
                                          onChange={this.onChangeCarad}
                                        />

                                        <div className="pb-20 pad-x-none clear">
                                          <div className="row">
                                            <CardInputMaskinking
                                              divClassName="input-field col s4 pad-x-none"
                                              field="cardMonth"
                                              label="Month *"
                                              placeholder="Month"
                                              value={cardMonth}
                                              error={
                                                cardErrors.cardMonth
                                              }
                                              onChange={this.onChangeCarad}
                                              mask="99"
                                            />

                                            <CardInputMaskinking
                                              divClassName="input-field col s4 pad-x-none checkoutyear-input"
                                              field="cardYear"
                                              label="Year *"
                                              placeholder="Year"
                                              value={cardYear}
                                              error={
                                                cardErrors.cardYear
                                              }
                                              onChange={this.onChangeCarad}
                                              mask="99"
                                            />

                                            <CardInputMaskinking
                                              divClassName="input-field col s4 pad-x-none"
                                              field="cardCvv"
                                              label="CVV *"
                                              placeholder="CVV"
                                              value={cardCvv}
                                              error={cardErrors.cardCvv}
                                              onChange={this.onChangeCarad}
                                              mask="9999"
                                            />


                                          </div>
                                        </div>

                                        <CardInputField
                                          divClassName="input-field col s12 pb-20 pad-x-none"
                                          field="cardAddress"
                                          label="Address *"
                                          // placeholder="Address"
                                          value={cardAddress}
                                          error={cardErrors.cardAddress}
                                          onChange={this.onChangeCarad}
                                        />

                                        <CardInputField
                                          divClassName="input-field col s12 pb-20 pad-x-none"
                                          field="cardAddress2"
                                          label="Address 2"
                                          // placeholder="Address"
                                          value={cardAddress2}
                                          onChange={this.onChangeCarad}
                                        />

                                        <div className="row city-state-zip">
                                          <CardInputField
                                            divClassName="input-field col s12 m5 pb-20-mob pad-x-none "
                                            field="cardCity"
                                            label="City *"
                                            // placeholder="City"
                                            value={cardCity}
                                            error={cardErrors.cardCity}
                                            onChange={this.onChangeCarad}
                                          />

                                          <div className="input-field col s12 col m3 pb-20-mob pad-x-none">
                                            <label className="active">
                                              State*
                                            </label>
                                            <select
                                              name="state"
                                              value={stateCard}
                                              onChange={this._onSelectCard}
                                              onClick={this._onSelectCard}
                                              className="state-select"
                                            >
                                              {typeof options !== "undefined"
                                                ? options
                                                : ""}
                                            </select>

                                            {/* <div className="col s4 input-half-lt custom-select">
                                      <label className="active font-scale">State*</label>
                                      <select name="state" onChange={this._onSelect}>
                                        {(typeof options !== 'undefined') ? (options) : ''}
                                      </select> */}

                                            <span
                                              className={
                                                cardErrors.stateCardError
                                                  ? "show invalid dropdown-error-msg"
                                                  : "hide"
                                              }
                                            >
                                              {cardErrors.stateCard}
                                            </span>
                                          </div>
                                          <CardInputMaskinking
                                            divClassName="input-field col s12 m4 pad-x-none"
                                            field="cardZipCode"
                                            label="Zip Code *"
                                            // placeholder="Zip Code"
                                            value={cardZipCode}
                                            error={
                                              cardErrors.cardZipCode
                                            }
                                            onChange={this.onChangeCarad}
                                            mask="99999"
                                          />
                                        </div>
                                        <div className="col s12 input-field pad-x-none">
                                          <ReCAPTCHA
                                            ref={this.recaptchaRef}
                                            sitekey={
                                              SecretKeys.FusebillCaptchKeys
                                            }
                                            onChange={this.onReCaptchaChange}
                                            onExpired={() => {
                                              this.setState( prevState => ({
                                                cardErrors: {
                                                  ...prevState.cardErrors,
                                                  recaptchaTokenError: true
                                                }}
                                              ))
                                            }}
                                          />
                                        </div>
                                      </div>
                                    </form>
                                  </div>
                                ) : (
                                  ""
                                )}
                                <div className="tab-inner center-align input-field claimant-btns checkout-btns pl-none">
                                  <button
                                    onClick={() => {
                                      this.setState({ tabValue: isBussnessState ? 1 : 0}, () => {
                                        window.scrollTo(0, 0);
                                      });
                                    }}
                                    className="waves-effect waves-light white-btn back-button back-button2 back-btn-pad-mob ml-mob-none"
                                    type="submit"
                                    name="action"
                                  >
                                    Back
                                  </button>
                                  <button
                                    className={
                                      this.props.match.params.affiliateKey ===
                                      undefined
                                        ? (planName !== "Basic" &&
                                          (planName,
                                          AllPlansForMember &&
                                          AllPlansForMember.records &&
                                          AllPlansForMember.records[
                                            enterpriseType === "S"
                                              ? "Small"
                                              : "Enterprise"
                                          ].findIndex(
                                            item1 =>
                                              item1.planName === planName
                                          ) !== -1
                                            ? AllPlansForMember &&
                                              AllPlansForMember.records &&
                                              AllPlansForMember.records[
                                                enterpriseType === "S"
                                                  ? "Small"
                                                  : "Enterprise"
                                              ][
                                                AllPlansForMember &&
                                                  AllPlansForMember.records &&
                                                  AllPlansForMember.records[
                                                    enterpriseType === "S"
                                                      ? "Small"
                                                      : "Enterprise"
                                                  ].findIndex(
                                                    item1 =>
                                                      item1.planName ===
                                                      planName
                                                  )
                                              ] &&
                                              AllPlansForMember &&
                                              AllPlansForMember.records &&
                                              AllPlansForMember.records[
                                                enterpriseType === "S"
                                                  ? "Small"
                                                  : "Enterprise"
                                              ][
                                                AllPlansForMember &&
                                                  AllPlansForMember.records &&
                                                  AllPlansForMember.records[
                                                    enterpriseType === "S"
                                                      ? "Small"
                                                      : "Enterprise"
                                                  ].findIndex(
                                                    item1 =>
                                                      item1.planName ===
                                                      planName
                                                  )
                                              ].planPriceDto[0]
                                                .connectFusebill === 1
                                              ? 1
                                              : 0
                                            : 0) !== 0
                                            ? isEmpty(cardErrors)
                                            : true) &&
                                          selectedPlanAmount !== ""
                                          ? "waves-effect waves-light pink-btn back-btn-pad-mob"
                                          : "waves-effect waves-light ltgrey-btn make-payment-action back-btn-pad-mob"
                                        : (planName !== "Basic" &&
                                          (planName,
                                          plansDataAffiliate &&
                                          plansDataAffiliate.result &&
                                          plansDataAffiliate.result
                                            .affiliateSubscriptionDto &&
                                          plansDataAffiliate.result
                                            .affiliateSubscriptionDto.map &&
                                          plansDataAffiliate.result.affiliateSubscriptionDto.map[
                                            enterpriseType === "S"
                                              ? "Small"
                                              : "Enterprise"
                                          ].findIndex(
                                            item1 =>
                                              item1.planName === planName
                                          ) !== -1
                                            ? plansDataAffiliate.result
                                                .affiliateSubscriptionDto.map[
                                                enterpriseType === "S"
                                                  ? "Small"
                                                  : "Enterprise"
                                              ][
                                                plansDataAffiliate.result.affiliateSubscriptionDto.map[
                                                  enterpriseType === "S"
                                                    ? "Small"
                                                    : "Enterprise"
                                                ].findIndex(
                                                  item1 =>
                                                    item1.planName ===
                                                    planName
                                                )
                                              ] &&
                                              plansDataAffiliate.result
                                                .affiliateSubscriptionDto.map[
                                                enterpriseType === "S"
                                                  ? "Small"
                                                  : "Enterprise"
                                              ][
                                                plansDataAffiliate.result.affiliateSubscriptionDto.map[
                                                  enterpriseType === "S"
                                                    ? "Small"
                                                    : "Enterprise"
                                                ].findIndex(
                                                  item1 =>
                                                    item1.planName ===
                                                    planName
                                                )
                                              ].planPriceDto[0]
                                                .connectFusebill === 1
                                              ? 1
                                              : 0
                                            : 0) !== 0
                                            ? isEmpty(cardErrors)
                                            : true) &&
                                          selectedPlanAmount !== ""
                                        ? "waves-effect waves-light pink-btn back-btn-pad-mob"
                                        : "waves-effect waves-light ltgrey-btn make-payment-action back-btn-pad-mob"
                                    }
                                    onClick={this.finalSubmit}

                                    disabled={
                                      this.props.match.params.affiliateKey ===
                                      undefined
                                        ? !(
                                            (planName !== "Basic" &&
                                            (planName,
                                            AllPlansForMember &&
                                            AllPlansForMember.records &&
                                            AllPlansForMember.records[
                                              enterpriseType === "S"
                                                ? "Small"
                                                : "Enterprise"
                                            ].findIndex(
                                              item1 =>
                                                item1.planName === planName
                                            ) !== -1
                                              ? AllPlansForMember &&
                                                AllPlansForMember.records &&
                                                AllPlansForMember.records[
                                                  enterpriseType === "S"
                                                    ? "Small"
                                                    : "Enterprise"
                                                ][
                                                  AllPlansForMember &&
                                                    AllPlansForMember.records &&
                                                    AllPlansForMember.records[
                                                      enterpriseType === "S"
                                                        ? "Small"
                                                        : "Enterprise"
                                                    ].findIndex(
                                                      item1 =>
                                                        item1.planName ===
                                                        planName
                                                    )
                                                ] &&
                                                AllPlansForMember &&
                                                AllPlansForMember.records &&
                                                AllPlansForMember.records[
                                                  enterpriseType === "S"
                                                    ? "Small"
                                                    : "Enterprise"
                                                ][
                                                  AllPlansForMember &&
                                                    AllPlansForMember.records &&
                                                    AllPlansForMember.records[
                                                      enterpriseType === "S"
                                                        ? "Small"
                                                        : "Enterprise"
                                                    ].findIndex(
                                                      item1 =>
                                                        item1.planName ===
                                                        planName
                                                    )
                                                ].planPriceDto[0]
                                                  .connectFusebill === 1
                                                ? 1
                                                : 0
                                              : 0) !== 0
                                              ? isEmpty(cardErrors)
                                              : true) &&
                                            selectedPlanAmount !== ""
                                          )
                                        : !(
                                            (planName !== "Basic" &&
                                            (planName,
                                            plansDataAffiliate &&
                                            plansDataAffiliate.result &&
                                            plansDataAffiliate.result
                                              .affiliateSubscriptionDto &&
                                            plansDataAffiliate.result
                                              .affiliateSubscriptionDto.map &&
                                            plansDataAffiliate.result.affiliateSubscriptionDto.map[
                                              enterpriseType === "S"
                                                ? "Small"
                                                : "Enterprise"
                                            ].findIndex(
                                              item1 =>
                                                item1.planName === planName
                                            ) !== -1
                                              ? plansDataAffiliate.result
                                                  .affiliateSubscriptionDto
                                                  .map[
                                                  enterpriseType === "S"
                                                    ? "Small"
                                                    : "Enterprise"
                                                ][
                                                  plansDataAffiliate.result.affiliateSubscriptionDto.map[
                                                    enterpriseType === "S"
                                                      ? "Small"
                                                      : "Enterprise"
                                                  ].findIndex(
                                                    item1 =>
                                                      item1.planName ===
                                                      planName
                                                  )
                                                ] &&
                                                plansDataAffiliate.result
                                                  .affiliateSubscriptionDto
                                                  .map[
                                                  enterpriseType === "S"
                                                    ? "Small"
                                                    : "Enterprise"
                                                ][
                                                  plansDataAffiliate.result.affiliateSubscriptionDto.map[
                                                    enterpriseType === "S"
                                                      ? "Small"
                                                      : "Enterprise"
                                                  ].findIndex(
                                                    item1 =>
                                                      item1.planName ===
                                                      planName
                                                  )
                                                ].planPriceDto[0]
                                                  .connectFusebill === 1
                                                ? 1
                                                : 0
                                              : 0) !== 0
                                              ? isEmpty(cardErrors)
                                              : true) &&
                                            selectedPlanAmount !== ""
                                          )
                                    }
                                    type="submit"
                                    name="action"
                                  >
                                    Submit Payment
                                  </button>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </TabPanel>
                    </div>
                  </div>


                </Tabs>
              </TabPanel>
            </Tabs>
          </div>
        </div>

    </div>
    );
  }
}

ProfileTermsPage.contextTypes = {
  router: PropTypes.object.isRequired
};

const mapStateToProps = state => ({ data: state.data });

const mapDispatchToProps = dispatch =>
  bindActionCreators(
    {
      updateConsumerUser,
      getConsumerUser,
      getAllPlans,
      getAllStates,
      getBusinessUser,
      updateUserSignatureWithDocs,
      updateBusinessUser,
      planPriceChange,
      requestCreateFusebillCustomer,
      requestSaveFusebillPaymentMethod,
      requestSaveFusebillCardId,
    },
    dispatch
  );

export default withAlert(
  connect(
    mapStateToProps,
    mapDispatchToProps
  )(ProfileTermsPage)
);
